













































































































































































































































































































import Vue, { PropOptions } from 'vue';
import { ThisTypedComponentOptionsWithRecordProps } from 'vue/types/options';
import { NOC, moment } from '@/class';
import {
  IGraphData,
  ITooltip,
  ILegend,
  IBannedAppValue,
} from '@/class/models/typed/gadget/basicGadget';
import { IGadgetSelectOptions } from '@/class/models/views/dashboard';
import * as dashboardModels from '@/class/models/views/dashboard';

import Charts from '@/components/charts';
import ListChart from '@/components/charts/ListChartV3.vue';
import SelectBox, { IOption } from '@/components/util/SelectBoxV3.vue';
import SelectBoxV4 from '@/components/util/SelectBoxV4.vue';
import MultiSelectBox from '@/components/util/MultiSelectBox.vue';
import GadgetFrame, {
  IFrame as iframe,
  CFrame,
} from './EditerGadgetFrameV3.vue';

import DatePicker from 'vuejs-datepicker';
import { ja } from 'vuejs-datepicker/dist/locale';
import ClickOutside from 'vue-click-outside';
import {
  clacValueToColor,
  GadgetMakerOpCountHeatmap,
  OP_COUNT_MIN,
} from './gadget_maker/GadgetMakerOpCountHeatmap';

interface Data {
  frameData: IFrame;

  targetSetDataValue: string;
  targetSetDataInfo: ISetData;
  compareTargetSetDataValue: string;
  compareTargetSetDataInfo: ISetData;
  preTargetDateValue: string;
  targetDateValue: string;
  targetDateType: string;
  targetDateShow: boolean;
  targetDateInitialValue: string;
  targetDateTo: string | undefined;
  // アラートグラフ用パラメータ
  bannedAppsValue: IBannedAppValue[] | undefined;
  cutoffDayValue: string | undefined;
  startdateValue: string | undefined;
  weekFirstValue: string | undefined;

  materials: models.IDomain[];
  selectGraphs: models.IDomain[];
  selectGraphValue: string;
  resData: models.VReturnGraphData;
  isDisplayLegend: boolean;
  legendList: ILegend[];
  tooltip: ITooltip;
  DatePickerMonth: string;
  DatePickerDate: string;
  dataObj: {};
  optionsObj: {};
  baseOptionsObj: {
    responsive: boolean;
    maintainAspectRatio: boolean;
    tooltips: typeof tooltipOption;
    legend: {
      display: boolean;
      position: string;
    };
    scales: {
      yAxes: Array<{
        display: boolean;
        value: {};
        ticks: {};
        stacked: boolean;
        gridLines: { display: boolean; drawBorder: boolean };
        id?: string;
        position?: string;
      }>;
      xAxes: Array<{
        display: boolean;
        value: {};
        ticks: {};
        stacked: boolean;
        gridLines: { display: boolean; drawBorder: boolean };
        id?: string;
        position?: string;
      }>;
    };
    plugins: {
      datalabels: {};
    };
  };
  widthX: number;
  heightX: number;
  loading: boolean;
  requestDataBack: string;
  options: { displayDate: string };
  optionsOld: { displayDate: string };
  optionItems: any[];
  ratio: number;
  inputingTitle: string;
  isSelectBoxOpen: boolean;
  isDatePickerOpen: boolean;
  isAlert: boolean;
  // ヒートマップ用
  colorbarValueMax: number;
}
interface Methods {
  setCompareTargetSetDataInfo: () => void;
  onClickZoom: () => void;
  onOutsideClick: () => void;
  onClickDatePicker: (event: any) => void;
  onCloseDatePicker: () => void;
  onChangeCompareTargetSelectBox: (event: any) => void;
  checkDetail: () => void;
  watchSetDataValue: (newValue: string, setDataInfo: ISetData) => Promise<void>;
  setGadgetData: (gadgetData: models.IGadget) => void;
  setSelectSetData: (
    newDomain: models.IDomain | undefined,
    setDataInfo: ISetData,
  ) => Promise<string>;
  setSelectDate: (newDomain: models.IDomain | undefined) => void;
  getDatePickerStr: (value: string) => string;
  setSize: () => void;
  frameDataEdit: (frameData: any) => void;
  editAction: () => void;
  detailAction: () => Promise<void>;
  getBasicGraphData: () => Promise<void>;
  setChartJsData: (gadgetDatas: models.IGraphData[]) => void;
  setOptions: () => void;
  hex2rgba: (hex: string, alpha: number) => string | null;
  getRatio: () => number;
  tooltipTitle: (tooltipItem: any[], data: any) => string[];
  tooltipLabel: (tooltipItem: any, data: any) => string;
  tooltipFooter: (tooltipItem: any[], data: any) => string[];
  customToolTips: (tooltipModel: any) => void;
  changeLegend: (newValue: string) => void;
  onClickLegend: (idx: number) => void;
  onMouseMoveGraphParent: (event: any) => void;
  pushAppDataSet: (
    datasets: any[],
    gadgetData: IGraphData,
    valueFunc: (v: number | string) => string,
    compareKey?: string,
  ) => void;
  pushUserDataSet: (
    datasets: any[],
    gadgetData: IGraphData,
    dataFunc: (v: number | string) => number | string,
    valueFunc: (v: number | string) => string,
    compareKey?: string,
    color?: string,
  ) => void;
  createDataset: (
    gadgetDatas: IGraphData[],
    measureKey: string,
    bgcolor: string,
    dataFunc: (v: IGraphData) => number | string,
    valueFunc: (v: number | string) => string,
  ) => any;
  setLabelsForMulti: (
    dataset: any,
    isAverage: boolean,
    measureKey: string,
    gadgetDatas: IGraphData[],
  ) => void;
  clacValueToColor: (value: number, min: number, max: number) => string;
}
interface Computed {
  DAY_OF_WEEKS: string[];
  YEAR_OPTIONS: any[];
  YEAR_SELECT: any[];
  MONTH_SELECT: any[];
  DAY_SELECT: any[];
  IS_ABLE_TO_COMPARE: boolean;
  IS_COMPARE_GRAPH: boolean;
  IS_COMPARE_SAME_SIGLE_MEASURES: boolean;
  IS_SELECT_APP_DOUGHNUT: boolean;
  IS_SELECT_HEATMAP: boolean;
  IS_MEMBER_COUNT_GRAPH: boolean;
  CT_SETDATA_CLASS: any;
  IS_MULTI: boolean;
  IS_GROUP: boolean;
  IS_GROUP_MULTI: boolean;
  IS_DEPARTMENT: boolean;
  IS_DEPARTMENT_MULTI: boolean;
  IS_PULLDOWN_STATUS: boolean;
  OP_COUNT_MIN: number;
}
interface Props {
  baseFrameData: IFrame;
  gadgetData: models.IGadget;
  helpmodal: string;
  w: number;
  h: number;
  resized: boolean;
  dashBoard: boolean;
  initialCt1List: IGadgetSelectOptions[];
  isSelectedType: boolean;
  users: dashboardModels.IUser[];
  department: dashboardModels.IDepartmentInfo[];
  selectedBoardType: number;
  navigation: dashboardModels.INavigation;
}

export interface IGraph {
  key: string;
  lable: string;
  src: string;
}

export type IFrame = iframe;
export { CFrame };

export const VUECHARTGRAPH = [
  { key: NOC.CHARTS.BAR, lable: '縦棒グラフ', src: '/images/g/1.png' },
  {
    key: NOC.CHARTS.HORIZONTALBAR,
    lable: '横棒グラフ',
    src: '/images/g/2.png',
  },
  { key: NOC.CHARTS.LINE, lable: '折れ線グラフ', src: '/images/g/6.png' },
  { key: NOC.CHARTS.DOUGHNUT, lable: '円グラフ', src: '/images/g/8.png' },
  { key: NOC.CHARTS.LIST, lable: 'リスト', src: '/images/g/7.png' },
  { key: NOC.CHARTS.STACKED_BAR, lable: '積上げ縦棒グラフ', src: '' },
  { key: NOC.CHARTS.STACKED_HORIZONTALBAR, lable: '積上げ横棒グラフ', src: '' },
] as IGraph[];

interface ISetData {
  prevValue: string;
  initialValue: string;
  options: IOption[];
  groupNames?: IOption[];
  departmentNames?: IOption[];
  show: boolean;
  open?: boolean;
}

// 通信
import API from '@/api/common';
import * as models from '@/class/models/views/graph';
import { IMaterial } from '@/class/common/const';
import {
  datalabelValueFormatter,
  datalabelNameFormatter,
  appDatalabelNameFormatter,
} from '@/components/charts/Doughnut.vue';
import { tooltipOption } from '@/parts/graph/GraphTooltip.vue';
import HeatmapColorBar from '../charts/HeatmapColorBar.vue';
import { HEATMAP_OP_COUNT_DEFAULT_MAX } from '@/class/common/const/operation-count-anyalysis-const';
import {
  makeAryByLength,
  makeAryByStartEnd,
} from '@/class/common/util/array_util';

const GRAPH_HW = 248;

export default Vue.extend({
  name: 'BasicGadget',
  components: {
    GadgetFrame,
    SelectBox,
    MultiSelectBox,
    ListChart,
    DatePicker,
    SelectBoxV4,
    HeatmapColorBar,
  },
  props: {
    baseFrameData: Object as PropOptions<IFrame>,
    gadgetData: Object as PropOptions<models.IGadget>,
    helpmodal: String,
    w: Number,
    h: Number,
    resized: {
      type: Boolean,
      default: true,
    },
    dashBoard: {
      type: Boolean,
      default: false,
    },
    isSelectedType: Boolean,
    initialCt1List: Array as PropOptions<IGadgetSelectOptions[]>,
    users: Array as PropOptions<dashboardModels.IUser[]>,
    department: Array as PropOptions<dashboardModels.IDepartmentInfo[]>,
    selectedBoardType: Number,
    navigation: Object as PropOptions<dashboardModels.INavigation>,
  },
  data() {
    return {
      frameData: {} as IFrame,
      targetSetDataValue: '',
      targetSetDataInfo: {
        prevValue: '',
        initialValue: '0',
        options: [] as IOption[],
        show: false,
      } as ISetData,
      compareTargetSetDataValue: '',
      compareTargetSetDataInfo: {
        prevValue: '',
        initialValue: '0',
        options: [] as IOption[],
        show: false,
        open: false,
      } as ISetData,
      preTargetDateValue: '',
      targetDateValue: '',
      targetDateType: '',
      targetDateShow: false,
      targetDateInitialValue: '',
      targetDateTo: undefined,
      bannedAppsValue: undefined,
      cutoffDayValue: undefined,
      startdateValue: undefined,
      weekFirstValue: undefined,
      materials: [] as models.IDomain[],
      selectGraphs: [] as models.IDomain[],
      selectGraphValue: '',
      resData: {} as models.VReturnGraphData,
      charts: Charts,
      isDisplayLegend: false,
      legendList: [] as ILegend[],
      tooltip: {} as ITooltip,
      DatePickerMonth: 'yyyy. M',
      DatePickerDate: 'yyyy. M. d',
      ja,
      dataObj: {},
      optionsObj: {},
      baseOptionsObj: {
        responsive: !this.dashBoard,
        maintainAspectRatio: !this.dashBoard,
        tooltips: tooltipOption,
        legend: {
          display: false,
          position: 'bottom',
        },
        scales: {
          yAxes: [
            {
              display: false,
              value: {},
              ticks: {},
              stacked: false,
              gridLines: { display: false, drawBorder: false },
            },
          ],
          xAxes: [
            {
              display: false,
              value: {},
              ticks: {},
              stacked: false,
              gridLines: { display: false, drawBorder: false },
            },
          ],
        },
        plugins: {
          datalabels: {
            color: '#fff',
            padding: 0,
            font: { lineHeight: 0 }, // topとbottomの間を詰める
            labels: {
              name: { align: 'top', font: { lineHeight: 0.9, size: 10 } },
              value: {
                align: 'bottom',
                font: { lineHeight: 1, size: 13, weight: 'bold' },
              },
            },
          },
        },
      },
      widthX: GRAPH_HW,
      heightX: GRAPH_HW,
      loading: false,
      requestDataBack: '',
      options: { displayDate: '' },
      optionsOld: { displayDate: '' },
      optionItems: [] as any[],
      ratio: 1,
      inputingTitle: '',
      isSelectBoxOpen: false,
      isDatePickerOpen: false,
      isAlert: false, // アラート通知の場合を示すフラグ
      colorbarValueMax: HEATMAP_OP_COUNT_DEFAULT_MAX, // ヒートマップカラーバーの最大値
    };
  },
  computed: {
    /*
    NO_DATA() {
      return NODATA;
    },
    */
    DAY_OF_WEEKS() {
      return ['日', '月', '火', '水', '木', '金', '土'];
    },
    // 対象選択ボックス：年
    YEAR_OPTIONS() {
      // 2020年から現在までの年を表示しておく。
      const now = new Date();
      const startYear = 2020;
      const endYear = now.getFullYear();
      const yearList = makeAryByStartEnd(startYear, endYear);
      return yearList.map(year => ({ text: String(year), value: year }));
    },
    YEAR_SELECT() {
      const today = new Date();
      return ['一昨年', '昨年', '今年'].map((v, index) => ({
        text: String(v),
        value: today.getFullYear() - 2 + index,
      }));
    },
    MONTH_SELECT() {
      const today = new Date();
      today.setMonth(today.getMonth() - 2);
      return ['先々月', '先月', '今月'].map((v, index) => {
        today.setMonth(today.getMonth() + 1);
        if (today.getMonth() === 0) {
          // 今月が１月の場合の先月
          return { text: String(v), value: `${today.getFullYear() - 1}-12` }; // 先月だけ年を1減らし月を12にする
        } else {
          return {
            text: String(v),
            value: `${today.getFullYear()}-${('0' + today.getMonth()).slice(
              -2,
            )}`,
          };
        }
      });
    },
    DAY_SELECT() {
      const today = new Date();
      today.setDate(today.getDate() - 3);
      return ['一昨日', '昨日', '今日'].map((v, index) => {
        today.setDate(today.getDate() + 1);
        return {
          text: String(v),
          value: `${today.getFullYear()}-${('0' + (today.getMonth() + 1)).slice(
            -2,
          )}-${today.getDate()}`,
        };
      });
    },
    IS_MULTI() {
      return this.materials.some(
        v => v.id === NOC.MATERIAL.V3.MATERIAL.DIMENSION_MEMBER.id,
      );
    },
    IS_GROUP() {
      return this.materials.some(
        v => v.id === NOC.MATERIAL.V3.MATERIAL.DIMENSION_GROUP.id,
      );
    },
    IS_GROUP_MULTI() {
      return this.materials.some(
        v => v.id === NOC.MATERIAL.V3.MATERIAL.TARGET_GROUP_MULTI.id,
      );
    },
    IS_DEPARTMENT() {
      return this.materials.some(
        v => v.id === NOC.MATERIAL.V3.MATERIAL_BETA.DIMENSION_DEPARTMENT.id,
      );
    },
    IS_DEPARTMENT_MULTI() {
      return this.materials.some(
        v => v.id === NOC.MATERIAL.V3.MATERIAL_BETA.TARGET_DEPARTMENT_MULTI.id,
      );
    },
    IS_ABLE_TO_COMPARE() {
      return (
        this.selectGraphValue !== NOC.CHARTS.HORIZONTALBAR &&
        this.selectGraphValue !== NOC.CHARTS.STACKED_HORIZONTALBAR
      );
    },
    IS_COMPARE_GRAPH() {
      let compareType = false;
      let compareTarget = false;
      let compareMeasure = false;
      for (const material of this.materials) {
        compareType =
          compareType ||
          material.domain === NOC.MATERIAL.V3.DOMAIN.COMPARE_TYPE;
        compareTarget =
          compareTarget ||
          material.domain === NOC.MATERIAL.V3.DOMAIN.COMPARE_TARGET;
        compareMeasure =
          compareMeasure ||
          material.domain === NOC.MATERIAL.V3.DOMAIN.COMPARE_MEASURE;
      }
      return compareType && compareTarget && compareMeasure;
    },
    IS_COMPARE_SAME_SIGLE_MEASURES() {
      // 比較元・比較先が単独の同一MEASUREか
      // if (this.IS_COMPARE_GRAPH) {
      //   const findKeys: any = this.materials.filter((v) => v.domain === 'MEASURE');
      //   const findCompareKeys = this.materials.filter((v) => v.domain === 'COMPARE_MEASURE');
      //   return findKeys.length === 1 && findCompareKeys.length === 1
      //     && findKeys[0].key === findCompareKeys[0].key;
      // } else {
      //   return false;
      // }

      // 第３次デザイン対応
      // 操作回数どうしの比較時、表示が"h"になってしまうのを回避するため
      // 比較グラフは必ず「実労働時間(山田太郎)」の表示にする
      return false;
    },
    IS_SELECT_APP_DOUGHNUT() {
      return (
        this.selectGraphValue === NOC.CHARTS.DOUGHNUT &&
        this.materials.some(v => v.id === 24)
      );
    },
    IS_SELECT_HEATMAP() {
      return this.selectGraphValue === NOC.CHARTS.HEATMAP;
    },
    IS_MEMBER_COUNT_GRAPH() {
      // 複数人/グループの円グラフ用（アプリ、比較グラフ以外）
      const multiDoughnutOption = NOC.OPTION.V2.getValues(
        this.options,
        NOC.OPTION.V2.KEY.MULTI_DOUGHNUT,
      );
      return (
        multiDoughnutOption &&
        !this.IS_COMPARE_GRAPH &&
        this.IS_MULTI &&
        this.selectGraphValue === NOC.CHARTS.DOUGHNUT &&
        !this.materials.some(
          v => v.id === NOC.MATERIAL.V3.MATERIAL.MEASURE_APP.id,
        )
      );
    },
    CT_SETDATA_CLASS() {
      const displayDate = this.options.displayDate;
      return {
        'ct-setdata': true,
        'year':
          this.targetDateShow &&
          this.targetDateType === '年' &&
          displayDate === 'date',
        'month':
          this.targetDateShow &&
          this.targetDateType === '月' &&
          displayDate === 'date',
        'date':
          this.targetDateShow &&
          this.targetDateType === '日' &&
          displayDate === 'date',
        'compare': this.compareTargetSetDataInfo.show && this.IS_ABLE_TO_COMPARE,
      };
    },
    IS_PULLDOWN_STATUS() {
      if (this.selectedBoardType === 2 && this.frameData.sample) {
        return true;
      } else if (this.selectedBoardType === 3 && this.frameData.sample) {
        return false;
      } else if (this.selectedBoardType === 1 && this.frameData.sample) {
        return true;
      } else {
        return NOC.OPTION.V2.getValues(
          this.options,
          NOC.OPTION.V2.KEY.CHANGE_PULLDOWN,
        );
      }
    },
    // 操作回数ヒートマップ用
    OP_COUNT_MIN(): number {
      return OP_COUNT_MIN;
    },
  },
  directives: {
    ClickOutside,
    DatePicker,
  },
  watch: {
    options: {
      deep: true,
      async handler(newValue: any) {
        if (
          NOC.OPTION.V2.getValues(
            this.optionsOld,
            NOC.OPTION.V2.KEY.DATA_SERIES,
          ) !==
          NOC.OPTION.V2.getValues(this.options, NOC.OPTION.V2.KEY.DATA_SERIES)
        ) {
          // データ系列が変更されたら再取得する
          await this.getBasicGraphData();

          const isDoughnut = this.selectGraphValue === NOC.CHARTS.DOUGHNUT;
          // オプション設定 カラー:カラフルの表示制御
          if (
            (this.IS_MULTI &&
              !NOC.OPTION.V2.getValues(
                this.options,
                NOC.OPTION.V2.KEY.DATA_SERIES,
              )) ||
            isDoughnut
          ) {
            this.optionItems[0].values[1].display = false;
          } else {
            this.optionItems[0].values[1].display = true;
          }
        }
        if (
          NOC.OPTION.V2.getValues(
            this.optionsOld,
            NOC.OPTION.V2.KEY.CHANGE_PULLDOWN,
          ) !==
          NOC.OPTION.V2.getValues(
            this.options,
            NOC.OPTION.V2.KEY.CHANGE_PULLDOWN,
          )
        ) {
          // プルダウン表示が変更されたら再取得
          await this.getBasicGraphData();
          await this.setSelectSetData(
            NOC.MATERIAL.V3.getTargetSetData(this.materials),
            this.targetSetDataInfo,
          );
        }
        // deep:trueのwatchではnewvalueとoldvalueが同じになるため手動で退避
        this.optionsOld = JSON.parse(JSON.stringify(this.options));
        if (this.resData.graphData) {
          this.setChartJsData(this.resData.graphData);
        }
        this.$emit('setOptions', this.options);
      },
    },
    gadgetData: {
      deep: true,
      async handler(newValue: models.IGadget, oldValue: models.IGadget) {
        if (!newValue.default) {
          // オプション設定の変更を反映
          const oldOptionsKeys = Object.keys(oldValue.options);
          for (const key of oldOptionsKeys) {
            if (
              key in newValue.options &&
              (oldValue.options as any)[key] !== (newValue.options as any)[key]
            ) {
              this.options = JSON.parse(JSON.stringify(newValue.options));
            }
          }
        }
        this.setGadgetData(newValue);
      },
    },
    // [変数監視] this.materialsが変更されたら。
    async materials(newValue: models.IDomain[], oldValue: models.IDomain[]) {
      let changeFlag = false;
      // target setdata
      {
        const newMatrerial = NOC.MATERIAL.V3.getTargetSetData(newValue);
        const oldMatrerial = NOC.MATERIAL.V3.getTargetSetData(oldValue);
        if (JSON.stringify(newMatrerial) !== JSON.stringify(oldMatrerial)) {
          this.targetSetDataValue = await this.setSelectSetData(
            newMatrerial,
            this.targetSetDataInfo,
          );
          this.checkDetail();
          changeFlag = true;
        }
        if (newMatrerial === undefined) {
          this.targetSetDataValue = await this.setSelectSetData(
            undefined,
            this.targetSetDataInfo,
          );
          this.checkDetail();
          changeFlag = true;
        }
      }
      // target date
      {
        const newTargetDate = NOC.MATERIAL.V3.getTargetDate(newValue);
        const oldTargetDate = NOC.MATERIAL.V3.getTargetDate(oldValue);
        if (JSON.stringify(newTargetDate) !== JSON.stringify(oldTargetDate)) {
          this.setSelectDate(newTargetDate);
          this.checkDetail();
          changeFlag = true;
        }
      }
      // measure
      {
        const newMatrerial = NOC.MATERIAL.V3.getMeasures(newValue);
        const oldMatrerial = NOC.MATERIAL.V3.getMeasures(oldValue);
        if (JSON.stringify(newMatrerial) !== JSON.stringify(oldMatrerial)) {
          changeFlag = true;
        }
      }
      // dimension date
      {
        const newMatrerial = NOC.MATERIAL.V3.getDimension(newValue);
        const oldMatrerial = NOC.MATERIAL.V3.getDimension(oldValue);
        if (JSON.stringify(newMatrerial) !== JSON.stringify(oldMatrerial)) {
          changeFlag = true;
        }
      }
      // type
      {
        const newMatrerial = NOC.MATERIAL.V3.getType(newValue);
        const oldMatrerial = NOC.MATERIAL.V3.getType(oldValue);
        if (JSON.stringify(newMatrerial) !== JSON.stringify(oldMatrerial)) {
          changeFlag = true;
        }
      }
      // compare graph --------------------------------------------------------
      // compare target setdata
      {
        const newMatrerial = NOC.MATERIAL.V3.getCompareTargetSetData(newValue);
        const oldMatrerial = NOC.MATERIAL.V3.getCompareTargetSetData(oldValue);
        if (JSON.stringify(newMatrerial) !== JSON.stringify(oldMatrerial)) {
          this.compareTargetSetDataValue = await this.setSelectSetData(
            newMatrerial,
            this.compareTargetSetDataInfo,
          );
          if (
            this.materials.some(
              v => v.id === NOC.MATERIAL.V3.MATERIAL.COMPARE_TARGET_COMPANY.id,
            )
          ) {
            this.compareTargetSetDataInfo.options = [
              { text: '全社', value: 0 },
            ];
          }
          changeFlag = true;
        }
      }
      // compare target
      {
        const newMatrerial = NOC.MATERIAL.V3.getCompareTargets(newValue);
        const oldMatrerial = NOC.MATERIAL.V3.getCompareTargets(oldValue);
        if (JSON.stringify(newMatrerial) !== JSON.stringify(oldMatrerial)) {
          changeFlag = true;
        }
      }
      // compare measure
      {
        const newMatrerial = NOC.MATERIAL.V3.getCompareMeasures(newValue);
        const oldMatrerial = NOC.MATERIAL.V3.getCompareMeasures(oldValue);
        if (JSON.stringify(newMatrerial) !== JSON.stringify(oldMatrerial)) {
          changeFlag = true;
        }
      }
      // compare type
      {
        const newMatrerial = NOC.MATERIAL.V3.getCompareType(newValue);
        const oldMatrerial = NOC.MATERIAL.V3.getCompareType(oldValue);
        if (JSON.stringify(newMatrerial) !== JSON.stringify(oldMatrerial)) {
          changeFlag = true;
        }
      }

      // console.log('changeFlag', changeFlag)
      if (changeFlag) {
        // option設定
        this.setOptions();
        // データ取得処理
        this.getBasicGraphData();
      }
    },
    async targetSetDataValue(value: string) {
      await this.watchSetDataValue(value, this.targetSetDataInfo);
    },
    async compareTargetSetDataValue(value: string) {
      await this.watchSetDataValue(value, this.compareTargetSetDataInfo);
    },
    targetDateValue() {
      if (this.targetDateType === '日') {
        this.targetDateValue = moment.fncChangeDateToInputForm(
          new Date(this.targetDateValue),
        );
      } else if (this.targetDateType === '月') {
        this.targetDateValue = moment.fncChangeMonthToInputForm(
          new Date(this.targetDateValue),
        );
      }
      // 同時に複数回呼び出されるので2回目以降は回避
      if (
        this.preTargetDateValue !== '' &&
        this.preTargetDateValue !== this.targetDateValue
      ) {
        this.$emit('setValues', [
          this.gadgetData,
          {
            setData: this.targetSetDataValue,
            date: this.targetDateValue,
            compareSetData: this.compareTargetSetDataValue,
          } as models.IValues,
        ]);
        this.getBasicGraphData();
      }
      this.preTargetDateValue = this.targetDateValue;
      // console.log('targetDateValue', this.targetDateValue);
    },
    w() {
      this.setSize();
    },
    h() {
      this.setSize();
    },
  },
  async mounted() {
    // 拡大縮小を行った際にアスペクト比によってグラフがぼやけるため、グラフを再読み込みする
    window.addEventListener('resize', () => {
      if (this.resData.graphData) {
        this.setChartJsData(this.resData.graphData);
      }
    });

    // データがある場合設定処理
    this.frameData = JSON.parse(JSON.stringify(this.baseFrameData));
    // options
    this.options = JSON.parse(JSON.stringify(this.gadgetData.options));
    this.setSize();
    if (this.gadgetData.data) {
      this.setGadgetData(this.gadgetData);
    }
    this.inputingTitle = this.gadgetData.title;

    // アラート通知の場合はフラグを設定
    this.isAlert = this.gadgetData.hasOwnProperty('isAlert');
  },
  methods: {
    setCompareTargetSetDataInfo() {
      if (
        this.materials.some(
          v => v.id === NOC.MATERIAL.V3.MATERIAL.COMPARE_TARGET_COMPANY.id,
        )
      ) {
        this.compareTargetSetDataInfo.options = [{ text: '全社', value: 0 }];
      }
    },
    onClickZoom() {
      this.$emit('zoom');
    },
    onOutsideClick() {
      this.compareTargetSetDataInfo.open = false;
    },
    onClickDatePicker(event: any) {
      if (this.targetDateType !== '年' && this.options.displayDate === 'date') {
        // DatePickerからのClickイベントのみ処理
        this.isDatePickerOpen = !this.isDatePickerOpen;
      }
      if (this.navigation && this.navigation.compareNavi) {
        // ナビ表示中はclickイベントを親要素に伝えない
        event.stopImmediatePropagation();
      }
    },
    onCloseDatePicker() {
      this.isDatePickerOpen = false;
    },
    // 比較対象セレクトボックスが変更されたとき。
    onChangeCompareTargetSelectBox(event) {
      this.compareTargetSetDataValue = event.toString();
    },
    // detail show flag
    checkDetail() {
      // todo:props objectで変えているがルール違反
      this.frameData.detail = false;
      const measureDate = NOC.MATERIAL.V3.getTargetDate(this.materials);
      if (measureDate) {
        const measureSetData = NOC.MATERIAL.V3.getTargetSetData(this.materials);
        if (measureSetData) {
          if (measureSetData.key === 'メンバー') {
            this.frameData.detail = true;
          }
        }
      }
    },
    async watchSetDataValue(newValue: string, setDataInfo: ISetData) {
      // 同時に複数回呼び出されるので2回目以降は回避
      if (setDataInfo.prevValue !== '' && setDataInfo.prevValue !== newValue) {
        this.$emit('setValues', [
          this.gadgetData,
          {
            setData: this.targetSetDataValue,
            date: this.targetDateValue,
            compareSetData: this.compareTargetSetDataValue,
          } as models.IValues,
        ]);
      }
      await this.getBasicGraphData();
      setDataInfo.prevValue = newValue;
    },
    setGadgetData(gadgetData: models.IGadget) {
      // initialValue
      if (gadgetData.data.values) {
        let targetSetDataInitialValue = gadgetData.data.values.setData;
        // 旧グラフの引継ぎ表示のためsetdataを変換
        // (FLAG_XXXを付与するのはGadgetEditerのみ)
        if (
          gadgetData.data.materials.some(
            v => v.id === NOC.MATERIAL.V3.MATERIAL.FLAG_GROUP_MEMBER.id,
          )
        ) {
          // グループ+メンバー毎：グループメンバー全員
          if (
            targetSetDataInitialValue &&
            targetSetDataInitialValue.indexOf('g') === -1 &&
            targetSetDataInitialValue.indexOf(',') === -1
          ) {
            targetSetDataInitialValue = `g${targetSetDataInitialValue}`;
          }
        } else if (
          gadgetData.data.materials.some(
            v => v.id === NOC.MATERIAL.V3.MATERIAL.FLAG_MULTI_MEMBER.id,
          )
        ) {
          // メンバー毎のみ選択：全員表示
          targetSetDataInitialValue =
            !targetSetDataInitialValue || targetSetDataInitialValue === '0'
              ? 'all'
              : targetSetDataInitialValue;
        }
        this.targetSetDataInfo.initialValue = targetSetDataInitialValue;

        this.targetDateInitialValue =
          gadgetData.data.values.date || moment.fncGetLastMonthDateStr();
        this.targetDateTo = gadgetData.data.values.dateto;
        const compareSetData = gadgetData.data.values.compareSetData;
        if (compareSetData) {
          this.compareTargetSetDataInfo.initialValue = compareSetData;
        }
        this.bannedAppsValue = gadgetData.data.values.bannedApps;
        this.cutoffDayValue = gadgetData.data.values.cutoffDay;
        this.startdateValue = gadgetData.data.values.startdate;
        this.weekFirstValue = gadgetData.data.values.weekFirst;
        if (this.dashBoard) {
          // ガジェット編集による日付変更を反映
          this.setSelectDate(NOC.MATERIAL.V3.getTargetDate(this.materials));
        } else {
          // プルダウンを変更せずにグラフ編集を保存する場合もプルダウン値を保存
          this.$emit('setValues', [
            this.gadgetData,
            {
              setData: this.targetSetDataInfo.initialValue,
              date: this.targetDateInitialValue,
              compareSetData: this.compareTargetSetDataInfo.initialValue,
            } as models.IValues,
          ]);
        }
      }
      // this.targetSetDataValue = gadgetData.data.values.date;
      // materials
      this.materials = JSON.parse(JSON.stringify(gadgetData.data.materials));
      // graph
      if (gadgetData.data.graph.length > 0) {
        let isChanged = false;
        if (this.selectGraphValue !== gadgetData.data.graph[0].key) {
          this.selectGraphValue = gadgetData.data.graph[0].key;
          isChanged = true;
        }
        if (gadgetData.data.graph.length > 1) {
          isChanged = true;
        }
        if (isChanged) {
          this.selectGraphs = gadgetData.data.graph;
          this.setOptions();
          if (this.resData.graphData) {
            this.setChartJsData(this.resData.graphData);
          }
          if (
            this.materials.some(
              v => v.id === NOC.MATERIAL.V3.MATERIAL.COMPARE_TARGET_COMPANY.id,
            )
          ) {
            this.compareTargetSetDataInfo.options = [
              { text: '全社', value: 0 },
            ];
          }
        }
      } else {
        this.selectGraphs = [];
        this.selectGraphValue = '';
      }
    },

    async setSelectSetData(
      newDomain: models.IDomain | undefined,
      setDataInfo: ISetData,
    ): Promise<string> {
      setDataInfo.show = false;
      // setDataInfo.show = true;
      let options = [NOC.SELECT.NOSELECT] as IOption[];
      let groupNames: IOption[] | undefined;
      let departmentNames: IOption[] | undefined;
      let initialValue = '0';
      const api = new API();
      let res;
      if (newDomain) {
        if (!this.initialCt1List) {
          if (newDomain.id === NOC.MATERIAL.V3.MATERIAL.TARGET_ALL.id) {
            // 複数人の場合、グループ名も取得
            res = await api.post<models.IDomain, IOption[]>(
              'gadget/ct1',
              NOC.MATERIAL.V3.MATERIAL.DIMENSION_GROUP,
            );
            if (res.result && res.data.length) {
              groupNames = res.data;
            }
            res = await api.post<models.IDomain, IOption[]>(
              'gadget/ct1',
              NOC.MATERIAL.V3.MATERIAL_BETA.DIMENSION_DEPARTMENT,
            );
            if (res.result && res.data.length) {
              departmentNames = res.data;
            }
          }
          res = await api.post<models.IDomain, IOption[]>(
            'gadget/ct1',
            newDomain,
          );
          if (res.result) {
            if (res.data.length > 0) {
              options = options.concat(res.data);
              // show = true;
              setDataInfo.show = true;
              setDataInfo.open = !this.dashBoard && !this.frameData.cover; // グラフ作成画面なら変わるたびに開く
              // console.log('this.setDataInfo.show', this.setDataInfo.show);
            }
          }
        } else {
          // 初期ロード時]
          // const result = this.initialCt1List.find((v) => (v.materialID === newDomain.id || v.materialID === NOC.MATERIAL.V3.MATERIAL.TARGET_ALL.id));
          const result = this.initialCt1List.find(
            v => v.materialID === newDomain.id,
          );
          if (result) {
            departmentNames = result.departmentNames;
            groupNames = result.groupNames;
            options = options.concat(result.selectOptions);
            setDataInfo.show = true;
          } else {
            // 初期ロード時、resultがundefindになりoptionsが空になってしまいプルダウンが表示されない場合があるため
            res = await api.post<models.IDomain, IOption[]>(
              'gadget/ct1',
              newDomain,
            );
            if (res.result) {
              if (res.data.length > 0) {
                options = options.concat(res.data);
                setDataInfo.show = true;
                // setDataInfo.open = !this.dashBoard && !this.frameData.cover; // グラフ作成画面なら変わるたびに開く
              }
            }
          }
        }
        this.loading = false;
      }
      if (newDomain === undefined) {
        // 全メンバーグラフの場合？
        if (this.initialCt1List) {
          const result = this.initialCt1List.find(
            v => v.materialID === NOC.MATERIAL.V3.MATERIAL.TARGET_ALL.id,
          );
          if (result) {
            groupNames = result.groupNames;
            options = options.concat(result.selectOptions);
            setDataInfo.show = true;
          }
        }
      }
      // this.targetSetDataShow = show;
      // this.targetSetDataInitialValue = initialValue;
      // todo 初期値が性格かどうか見る
      // 初期値の有無
      // console.log('targetSetDataInitialValue', this.targetSetDataInitialValue);
      if (setDataInfo.initialValue !== '0') {
        // await this.getBasicGraphData();
        initialValue = setDataInfo.initialValue;
      }
      setDataInfo.departmentNames = departmentNames;
      setDataInfo.groupNames = groupNames;
      setDataInfo.options = options;

      // this.targetSetDataValue = initialValue;
      return initialValue;
    },
    setSelectDate(newDomain: models.IDomain | undefined) {
      let type = '';
      let value = '';
      let show = false;
      if (newDomain) {
        type = newDomain.key;
        show = true;
        // console.log(this.targetDateInitialValue);
        if (this.targetDateInitialValue) {
          value = this.targetDateInitialValue;
        } else {
          // typeに応じた初期値
          value = moment.fncGetLastMonthDateStr();
        }
        switch (newDomain.id) {
          case 4:
            value = value.substr(0, 4);
            break;
          case 5:
            value = value.substr(0, 7);
            break;
          case 6:
            break;
        }
      }

      // 初期表示か否かの判定
      const initFlag = this.targetDateType ? false : true;

      this.targetDateType = type;
      this.targetDateValue = value;
      this.targetDateShow = show;

      // 初期表示且つtypeが日かつアラート通知以外の場合なら前日の日付を指定する
      if (initFlag && this.targetDateType === '日' && !this.isAlert) {
        this.targetDateValue = moment.fncGetYesterDay(
          new Date().toLocaleDateString(),
        );
      }
    },
    getDatePickerStr(value: string): string {
      const splited = value.split('-');
      const formated = splited.map(v => Number(v));
      return formated.join('. ');
    },
    setSize() {
      this.heightX = GRAPH_HW * this.h;
      this.widthX = GRAPH_HW * this.w;
    },
    frameDataEdit(frameData: any) {
      this.inputingTitle = frameData.title;
      this.$emit('frameDataEdit', frameData);
    },
    editAction() {
      this.$emit('edit', this.gadgetData);
    },
    async detailAction() {
      // this.$emit('showDetail', this.materials);
      // console.log('detail');
      const detailData = {
        setData: this.targetSetDataValue,
        date: this.targetDateValue,
      } as models.IValues;
      // console.log(detailData);
      this.$emit('showDetail', detailData);
    },
    async getBasicGraphData() {
      // console.log(`getBasicGraphData selectGraphValue:${this.selectGraphValue}`);
      // console.log('this.materials', this.materials);
      try {
        this.frameData.error = false;
        this.resData = {} as models.VReturnGraphData;
        if (this.selectGraphValue !== '') {
          // 各種値がない時は取得しない
          if (NOC.MATERIAL.V3.getTargets(this.materials).length <= 0) {
            // console.log('no targets');
            return;
          }
          if (NOC.MATERIAL.V3.getMeasures(this.materials).length <= 0) {
            // console.log('no measures');
            return;
          }
          if (NOC.MATERIAL.V3.getDimensions(this.materials).length <= 0) {
            // console.log('no dimensions');
            return;
          }
          const setDataDomain = NOC.MATERIAL.V3.getTargetSetData(
            this.materials,
          );
          if (setDataDomain && this.targetSetDataValue === '') {
            // console.log('no targetSetDataValue');
            return;
          }
          if (
            NOC.MATERIAL.V3.getTargetDate(this.materials) &&
            this.targetDateValue === ''
          ) {
            // console.log('no targetDateValue');
            return;
          }
          if (this.IS_ABLE_TO_COMPARE) {
            const compareTargets = NOC.MATERIAL.V3.getCompareTargets(
              this.materials,
            );
            const compareMeasures = NOC.MATERIAL.V3.getCompareMeasures(
              this.materials,
            );
            const compareType = NOC.MATERIAL.V3.getCompareType(this.materials);
            if (
              compareTargets.length > 0 &&
              compareMeasures.length > 0 &&
              compareType
            ) {
              // 比較グラフ項目が全て設定されていたらグラフ取得
              if (compareTargets[0].kingdom) {
                // compare target setdata
                const compareSetData = NOC.MATERIAL.V3.getCompareTargetSetData(
                  this.materials,
                );
                if (
                  !compareSetData
                  // || this.compareTargetSetDataValue === String(NOC.SELECT.NOSELECT.value) // 比較対象で「未選択」を選択した時はグラフデータを取得しない。 note takezawa 「未選択」のときでもグラフ表示するように修正。不具合なければ削除。
                ) {
                  this.requestDataBack = '';
                  return;
                }
              }
            } else if (
              compareTargets.length > 0 ||
              compareMeasures.length > 0 ||
              compareType
            ) {
              // 一部だけが選択されている場合は取得しない
              return;
            }
          }
          // データを取得する関数を呼び出す。
          this.loading = true;
          const api = new API();
          const requestData = {
            materials: this.materials,
            values: {
              setData: this.targetSetDataValue,
              date: this.targetDateValue,
              datefrom: this.targetDateInitialValue,
              dateto: this.targetDateTo,
              compareSetData: this.compareTargetSetDataValue,
              bannedApps: this.bannedAppsValue,
              cutoffDay: this.cutoffDayValue,
              startdate: this.startdateValue,
              weekFirst: this.weekFirstValue,
            },
            options: this.options,
          } as models.VGetGraphData;
          const requestDataStr = JSON.stringify(requestData);
          if (requestDataStr === this.requestDataBack) {
            return;
          }
          this.requestDataBack = requestDataStr;
          const res = await api.post<
            models.VGetGraphData,
            models.VReturnGraphData
          >('gadget/basic_graph', requestData);
          if (res.result) {
            if (requestDataStr !== this.requestDataBack) {
              // 既に別のグラフがリクエストされている場合はキャンセル
              return;
            }
            this.resData = res.data;
            // this.$emit('setNowData', this.resData);
            // 日毎設定で楽々30000になるため設定しない
            this.setChartJsData(this.resData.graphData);
            // this.$emit('setTitle');
          } else {
            // this.error = true;
          }
          this.loading = false;
        }
      } catch (e) {
        console.error(e);
        this.frameData.error = true;
      }
    },
    setChartJsData(gadgetDatas: models.IGraphData[]) {
      // console.log('setChartJsData');
      let datasets = [] as any[];
      let labels = [] as any[];
      try {
        this.frameData.error = false;
        let tmpOptionObj = JSON.parse(JSON.stringify(this.baseOptionsObj));
        let isTicksHour = true;
        const zeroHyphen = (
          v: number | string,
          callback: (num: number) => string,
        ) => {
          const num = Number(v);
          return num === 0 && this.selectGraphValue === NOC.CHARTS.LIST
            ? '-'
            : callback(num);
        };
        let valueFunc = (v: number | string) =>
          zeroHyphen(v, num => `${Math.round(num * 100) / 100}h`);
        const countValueFunc = (v: number | string) =>
          zeroHyphen(v, num => `${Math.round(num * 100) / 100}回`);
        const timeValueFunc = (v: number | string) => {
          const dateValue = new Date(v);
          return isNaN(dateValue.getTime())
            ? '-'
            : moment.fncChangeCustomTimeInputForm(dateValue);
        };
        if (gadgetDatas) {
          // 図ごとの処理
          switch (this.selectGraphValue) {
            // 縦 ---------------------------------------
            case NOC.CHARTS.STACKED_BAR:
              tmpOptionObj.scales.xAxes[0].stacked = true;
              tmpOptionObj.scales.yAxes[0].stacked = true;
            // breakなし
            case NOC.CHARTS.BAR:
            case NOC.CHARTS.LINE:
              tmpOptionObj.scales.yAxes[0].display = true;
              tmpOptionObj.scales.xAxes[0].display = true;
              tmpOptionObj.scales.xAxes[0].gridLines.display = false;
              tmpOptionObj.scales.yAxes[0].gridLines.display = true;
              tmpOptionObj.scales.xAxes[0].gridLines.drawBorder = true;
              tmpOptionObj.scales.yAxes[0].gridLines.drawBorder = false;
              break;
            // 横 ---------------------------------------
            case NOC.CHARTS.STACKED_HORIZONTALBAR:
              tmpOptionObj.scales.xAxes[0].stacked = true;
              tmpOptionObj.scales.yAxes[0].stacked = true;
            // breakなし
            case NOC.CHARTS.HORIZONTALBAR:
              tmpOptionObj.scales.yAxes[0].display = true;
              tmpOptionObj.scales.xAxes[0].display = true;
              tmpOptionObj.scales.xAxes[0].gridLines.display = true;
              tmpOptionObj.scales.yAxes[0].gridLines.display = false;
              tmpOptionObj.scales.xAxes[0].gridLines.drawBorder = false;
              tmpOptionObj.scales.yAxes[0].gridLines.drawBorder = true;
              break;
          }

          // x軸の作成
          let labelsFunction = (v: models.IGraphData[]) => v.map(y => y.label);
          const numStr = (v: string) =>
            v !== '' && !Number.isNaN(Number(v)) ? Number(v) : ' ';
          const dayOfWeeks = (v: string) => {
            const date = new Date(v);
            return !Number.isNaN(date.getTime())
              ? `（${this.DAY_OF_WEEKS[date.getDay()]}）`
              : ' ';
          };
          // note takezawa おそらくV2からV3へのマテリアル変換処理をしているものと思われる。
          // todo takezawa materialsForJudge は削除して、4,16, 6,17, 6,18 のswitch判定に統合できないか検討する。
          const materialsForJudge = JSON.parse(JSON.stringify(this.materials));
          if (
            NOC.OPTION.V2.getValues(this.options, NOC.OPTION.V2.KEY.DATA_SERIES)
          ) {
            for (const material of this.materials) {
              switch (material.id) {
                case 4: // 年
                  materialsForJudge.push(
                    NOC.MATERIAL.V3.MATERIAL.DIMENSION_MONTH,
                  );
                  break;
                case 5: // 月
                  materialsForJudge.push(
                    NOC.MATERIAL.V3.MATERIAL.DIMENSION_DATE,
                  );
                  break;
                case 6: // 日
                  materialsForJudge.push(
                    NOC.MATERIAL.V3.MATERIAL.DIMENSION_HOUR,
                  );
                  break;
                case NOC.MATERIAL.V3.MATERIAL.DIMENSION_DAYS_HOUR.id: // 24超え時毎
                  materialsForJudge.push(
                    NOC.MATERIAL.V3.MATERIAL.DIMENSION_DAYS_HOUR,
                  );
                  break;
              }
            }
          }
          for (const material of materialsForJudge) {
            switch (material.id) {
              case 16: // 月毎
                labelsFunction = (v: models.IGraphData[]) =>
                  v.map(
                    y => `${numStr(y.label.substr(y.label.length - 2, 2))}月`,
                  );
                break;
              case 17: {
                // 日毎
                for (const material2 of materialsForJudge) {
                  switch (material2.id) {
                    case 4:
                      // 年・日毎は旧グラフ作成画面で作成可
                      labelsFunction = (v: models.IGraphData[]) =>
                        v.map(y => `${numStr(y.label.substr(5, 5))}日`);
                      break;
                    case 5:
                      labelsFunction =
                        this.selectGraphValue === NOC.CHARTS.LIST
                          ? (v: models.IGraphData[]) =>
                              v.map(
                                y =>
                                  `${numStr(y.label.substr(5, 2))}月 ${numStr(
                                    y.label.substr(8, 2),
                                  )}日${dayOfWeeks(y.label)}`,
                              )
                          : (v: models.IGraphData[]) =>
                              v.map(y => `${numStr(y.label.substr(8, 2))}日`);
                      break;
                  }
                }
                break;
              }
              case 18: // 時毎
                labelsFunction = (v: models.IGraphData[]) =>
                  v.map(y => `${numStr(y.label)}時`);
                isTicksHour = false;
                break;
              case NOC.MATERIAL.V3.MATERIAL.DIMENSION_DAYS_HOUR.id: // 24H超え時毎
                labelsFunction = (v: models.IGraphData[]) =>
                  v.map(y => {
                    const hh = numStr(y.label.slice(-2));
                    return hh === 0
                      ? `${numStr(y.label.slice(0, 2))}日${hh}時`
                      : `${hh}時`;
                  });
                isTicksHour = false;
                break;
            }
          }
          // ラベル設定
          labels = labelsFunction(gadgetDatas);
          labels = labels.map((v: string) =>
            v.length <= 10 ? v : v.substring(0, 8) + '...',
          );
          // y軸の作成
          let defaultTicksObj;
          if (isTicksHour) {
            defaultTicksObj = {
              callback: (label: any, index: any, xylabels: any[]) =>
                label.toString() + 'h',
            };
          } else {
            defaultTicksObj = {
              stepSize: 0.25,
              callback: (label: any, index: any, xylabels: any[]) =>
                (label * 4 * 15).toString() + 'm',
            };
            valueFunc = (v: number | string) =>
              zeroHyphen(v, num => `${Math.round(num * 6000) / 100}m`);
          }
          const defaultCountTicksObj = {
            callback: (label: any, index: any, xylabels: any[]) =>
              label.toString() + '回',
          };
          let ticksObj;
          let secondTicksObj;

          // ディメンション
          // 比較グラフのmeasure
          // 複数メンバー、複数グループの場合比較データは通常グラフと一緒に来るので処理不要
          // 但しアプリだけ表示用処理が必要
          let compareKey = '';
          if (this.IS_COMPARE_GRAPH) {
            const compareTargets = NOC.MATERIAL.V3.getCompareTargets(
              this.materials,
            );
            for (const compareTarget of compareTargets) {
              switch (compareTarget.id) {
                case NOC.MATERIAL.V3.MATERIAL.COMPARE_TARGET_MEMBER.id:
                case NOC.MATERIAL.V3.MATERIAL.COMPARE_TARGET_GROUP.id:
                case NOC.MATERIAL.V3.MATERIAL_BETA.COMPARE_TARGET_DEPARTMENT
                  .id: {
                  const selectedValue = this.compareTargetSetDataInfo.options.find(
                    v => String(v.value) === this.compareTargetSetDataValue,
                  );
                  compareKey = selectedValue ? selectedValue.text : '比較対象';
                  break;
                }
                case NOC.MATERIAL.V3.MATERIAL.COMPARE_TARGET_COMPANY.id:
                  compareKey = '全社';
                  break;
                // case NOC.MATERIAL.V3.MATERIAL.COMPARE_TARGET_ALL.id: // 全国グラフは未実装
                //   compareKey = '全国';
                //   break;
              }
            }
          }

          // メジャー　就業時間とか
          let measures = NOC.MATERIAL.V3.getMeasures(this.materials);
          let compareMeasures: IMaterial[] = [];
          if (
            this.IS_ABLE_TO_COMPARE &&
            this.IS_COMPARE_GRAPH &&
            this.IS_MULTI
          ) {
            // 複数人の比較グラフで比較元・比較先が異なるデータの組み合わせでも表示できるようにする
            compareMeasures = NOC.MATERIAL.V3.getCompareMeasures(
              this.materials,
            );
            measures = measures.concat(compareMeasures);
          }
          const isAverage = this.materials.some(
            v => v.id === NOC.MATERIAL.V3.MATERIAL.TYPE_AVERAGE.id,
          );
          const getOptionColorType = NOC.OPTION.V2.getValues(
            this.options,
            NOC.OPTION.V2.KEY.COLOR,
          );
          // 各種データの処理 -------------------------------------------------------
          for (const measure of measures) {
            let measureKey = measure.key;
            if (
              this.selectGraphValue === NOC.CHARTS.LIST &&
              measure.id !== 36
            ) {
              measureKey = measureKey.replace('時間', '');
            }
            // 比較グラフの場合labelは名前やグループ名、部署名
            if (this.IS_COMPARE_GRAPH && !this.IS_MULTI) {
              const value: any = this.targetSetDataInfo.options.find(
                option => this.targetSetDataValue === String(option.value),
              );
              if (value && value.text) {
                if (isAverage) {
                  // 平均グラフの場合は'平均'を追加
                  measureKey = !this.IS_COMPARE_SAME_SIGLE_MEASURES
                    ? `${measureKey} 平均（${value.text}）`
                    : `${value.text} 平均`;
                } else {
                  // 集計グラフ
                  measureKey = !this.IS_COMPARE_SAME_SIGLE_MEASURES
                    ? `${measureKey}（${value.text}）`
                    : value.text;
                }
              }
            }
            switch (
              measure.id // 実労働時間
            ) {
              /* 勤務時間 */ case NOC.MATERIAL.V3.MATERIAL
                .COMPARE_MEASURE_WORKING_TIME.id:
                // 比較元・比較先で同じデータが選択されていたら比較先は処理しない（他も同様）
                if (
                  measures.some(
                    v =>
                      v.id === NOC.MATERIAL.V3.MATERIAL.MEASURE_WORKING_TIME.id,
                  )
                ) {
                  break;
                }
              case NOC.MATERIAL.V3.MATERIAL.MEASURE_WORKING_TIME.id: {
                if (
                  NOC.OPTION.V2.getValues(
                    this.options,
                    NOC.OPTION.V2.KEY.DATA_SERIES,
                  ) &&
                  gadgetDatas[0]
                ) {
                  const newlabels = labelsFunction(
                    (gadgetDatas[0].userLabels || []).map(v => ({ label: v })),
                  );
                  labels =
                    this.IS_MULTI && labels.length > 1
                      ? newlabels.concat(labels[labels.length - 1])
                      : newlabels;
                  this.pushUserDataSet(
                    datasets,
                    gadgetDatas[0],
                    v => Number(v) / 4,
                    valueFunc,
                    '',
                    getOptionColorType,
                  );
                  ticksObj = defaultTicksObj;
                  break;
                }
                // const newDataset = this.createDataset(gadgetDatas, measureKey, NOC.GRAPH.OPTIONS.BCOLOR_BETA[0],
                // const newDataset = this.createDataset(gadgetDatas, measureKey, NOC.GRAPH.OPTIONS.BCOLOR_BETA[0],
                const newDataset = this.createDataset(
                  gadgetDatas,
                  measureKey,
                  NOC.GRAPH.OPTIONS.BCOLOR_BLUE_ONLY[0],
                  v => Number(v.workTime || 0) / 4,
                  valueFunc,
                );
                this.setLabelsForMulti(
                  newDataset,
                  isAverage,
                  measureKey,
                  gadgetDatas,
                );
                datasets.push(newDataset);
                ticksObj = defaultTicksObj;
                labels = this.IS_MEMBER_COUNT_GRAPH
                  ? newDataset.labels
                  : labels;
                break;
              }

              /* 残業時間 */
              case NOC.MATERIAL.V3.MATERIAL.COMPARE_MEASURE_OVER_TIME.id:
                if (
                  measures.some(
                    v => v.id === NOC.MATERIAL.V3.MATERIAL.MEASURE_OVER_TIME.id,
                  )
                ) {
                  break;
                }
              case NOC.MATERIAL.V3.MATERIAL.MEASURE_OVER_TIME.id:
              case NOC.MATERIAL.V3.MATERIAL.MEASURE_OVER_TIME_AGREED.id:
              case NOC.MATERIAL.V3.MATERIAL.MEASURE_OVER_TIME_LEGAL_1.id:
              case NOC.MATERIAL.V3.MATERIAL.MEASURE_OVER_TIME_LEGAL_4.id:
              case NOC.MATERIAL.V3.MATERIAL.MEASURE_OVER_TIME_LEGAL_FLEX.id: {
                if (
                  NOC.OPTION.V2.getValues(
                    this.options,
                    NOC.OPTION.V2.KEY.DATA_SERIES,
                  ) &&
                  gadgetDatas[0]
                ) {
                  const newlabels = labelsFunction(
                    (gadgetDatas[0].userLabels || []).map(v => ({ label: v })),
                  );
                  labels =
                    this.IS_MULTI && labels.length > 1
                      ? newlabels.concat(labels[labels.length - 1])
                      : newlabels;
                  this.pushUserDataSet(
                    datasets,
                    gadgetDatas[0],
                    v => Number(v) / 4,
                    valueFunc,
                    '',
                    getOptionColorType,
                  );
                  ticksObj = defaultTicksObj;
                  break;
                }
                const newDataset = this.createDataset(
                  gadgetDatas,
                  measureKey,
                  NOC.GRAPH.OPTIONS.BCOLOR_BETA[1],
                  v =>
                    Number(v.overTime || 0) <= 0 ? 0 : Number(v.overTime) / 4,
                  valueFunc,
                );
                this.setLabelsForMulti(
                  newDataset,
                  isAverage,
                  measureKey,
                  gadgetDatas,
                );
                datasets.push(newDataset);
                ticksObj = defaultTicksObj;
                labels = this.IS_MEMBER_COUNT_GRAPH
                  ? newDataset.labels
                  : labels;
                break;
              }

              /* 所定労働時間外（フレックス） */
              case NOC.MATERIAL.V3.MATERIAL.MEASURE_OVER_TIME_AGREED_FLEX.id: {
                // const newDataset = this.createDataset(gadgetDatas, measureKey, NOC.GRAPH.OPTIONS.BCOLOR_BETA[1],
                const newDataset = this.createDataset(
                  gadgetDatas,
                  measureKey,
                  NOC.GRAPH.OPTIONS.BCOLOR_BETA[3],
                  v =>
                    v.workTime && v.fixedTime
                      ? Math.max(0, Number(v.workTime) - Number(v.fixedTime)) /
                        4
                      : 0,
                  valueFunc,
                );
                datasets.push(newDataset);
                ticksObj = defaultTicksObj;
                break;
              }

              /* 就業未達成時間 */
              case NOC.MATERIAL.V3.MATERIAL.COMPARE_MEASURE_UNACHIEVED_TIME.id:
                if (
                  measures.some(
                    v =>
                      v.id ===
                      NOC.MATERIAL.V3.MATERIAL.MEASURE_UNACHIEVED_TIME.id,
                  )
                ) {
                  break;
                }
              case NOC.MATERIAL.V3.MATERIAL.MEASURE_UNACHIEVED_TIME.id: {
                if (
                  NOC.OPTION.V2.getValues(
                    this.options,
                    NOC.OPTION.V2.KEY.DATA_SERIES,
                  ) &&
                  gadgetDatas[0]
                ) {
                  const newlabels = labelsFunction(
                    (gadgetDatas[0].userLabels || []).map(v => ({ label: v })),
                  );
                  labels =
                    this.IS_MULTI && labels.length > 1
                      ? newlabels.concat(labels[labels.length - 1])
                      : newlabels;
                  this.pushUserDataSet(
                    datasets,
                    gadgetDatas[0],
                    v => Number(v) / 4,
                    valueFunc,
                    '',
                    getOptionColorType,
                  );
                  ticksObj = defaultTicksObj;
                  break;
                }
                const newDataset = this.createDataset(
                  gadgetDatas,
                  measureKey,
                  '#FF8080',
                  v =>
                    Number(v.workTime || 0) >= Number(v.fixedTime || 0)
                      ? 0
                      : (Number(v.workTime || 0) - Number(v.fixedTime || 0)) /
                        4,
                  valueFunc,
                );
                this.setLabelsForMulti(
                  newDataset,
                  isAverage,
                  measureKey,
                  gadgetDatas,
                );
                datasets.push(newDataset);
                ticksObj = defaultTicksObj;
                labels = this.IS_MEMBER_COUNT_GRAPH
                  ? newDataset.labels
                  : labels;
                break;
              }

              /* 就業時間 (第二次デザインまで) */
              case NOC.MATERIAL.V3.MATERIAL.MEASURE_SETTING_TIME.id: {
                // const newDataset = this.createDataset(gadgetDatas, measureKey, NOC.GRAPH.OPTIONS.BCOLOR_BETA[3],
                const newDataset = this.createDataset(
                  gadgetDatas,
                  measureKey,
                  NOC.GRAPH.OPTIONS.BCOLOR_BETA[9],
                  v => Number(v.fixedTime || 0) / 4,
                  valueFunc,
                );
                datasets.push(newDataset);
                ticksObj = defaultTicksObj;
                break;
              }

              /* インターバル */
              case NOC.MATERIAL.V3.MATERIAL.COMPARE_MEASURE_INTERVAL_TIME.id:
                if (
                  measures.some(
                    v =>
                      v.id ===
                      NOC.MATERIAL.V3.MATERIAL.MEASURE_INTERVAL_TIME.id,
                  )
                ) {
                  break;
                }
              case NOC.MATERIAL.V3.MATERIAL.MEASURE_INTERVAL_TIME.id: {
                if (
                  NOC.OPTION.V2.getValues(
                    this.options,
                    NOC.OPTION.V2.KEY.DATA_SERIES,
                  ) &&
                  gadgetDatas[0]
                ) {
                  const newlabels = labelsFunction(
                    (gadgetDatas[0].userLabels || []).map(v => ({ label: v })),
                  );
                  labels =
                    this.IS_MULTI && labels.length > 1
                      ? newlabels.concat(labels[labels.length - 1])
                      : newlabels;
                  this.pushUserDataSet(
                    datasets,
                    gadgetDatas[0],
                    v => Number(v) / 4,
                    valueFunc,
                    '',
                    getOptionColorType,
                  );
                  ticksObj = defaultTicksObj;
                  break;
                }
                const newDataset = this.createDataset(
                  gadgetDatas,
                  measureKey,
                  NOC.GRAPH.OPTIONS.BCOLOR_BETA[2],
                  v => Number(v.intervalTime || 0) / 4,
                  valueFunc,
                );
                this.setLabelsForMulti(
                  newDataset,
                  isAverage,
                  measureKey,
                  gadgetDatas,
                );
                datasets.push(newDataset);
                ticksObj = defaultTicksObj;
                labels = this.IS_MEMBER_COUNT_GRAPH
                  ? newDataset.labels
                  : labels;
                break;
              }

              /* 操作回数 */
              case NOC.MATERIAL.V3.MATERIAL.COMPARE_MEASURE_COUNT.id:
                if (
                  measures.some(
                    v => v.id === NOC.MATERIAL.V3.MATERIAL.MEASURE_COUNT.id,
                  )
                ) {
                  break;
                }
              case NOC.MATERIAL.V3.MATERIAL.MEASURE_COUNT.id: {
                if (
                  NOC.OPTION.V2.getValues(
                    this.options,
                    NOC.OPTION.V2.KEY.DATA_SERIES,
                  ) &&
                  gadgetDatas[0]
                ) {
                  const newlabels = labelsFunction(
                    (gadgetDatas[0].userLabels || []).map(v => ({ label: v })),
                  );
                  labels =
                    this.IS_MULTI && labels.length > 1
                      ? newlabels.concat(labels[labels.length - 1])
                      : newlabels;
                  this.pushUserDataSet(
                    datasets,
                    gadgetDatas[0],
                    v => v,
                    countValueFunc,
                    '',
                    getOptionColorType,
                  );
                  ticksObj = defaultCountTicksObj;
                  break;
                }
                const newDataset = this.createDataset(
                  gadgetDatas,
                  measureKey,
                  NOC.GRAPH.OPTIONS.BCOLOR_BETA[4],
                  v => Number(v.count || 0),
                  countValueFunc,
                );
                if (
                  this.selectGraphValue === NOC.CHARTS.HORIZONTALBAR ||
                  this.selectGraphValue === NOC.CHARTS.STACKED_HORIZONTALBAR
                ) {
                  newDataset.xAxisID = 'axis-count';
                } else {
                  newDataset.yAxisID = 'axis-count';
                }
                this.setLabelsForMulti(
                  newDataset,
                  isAverage,
                  measureKey,
                  gadgetDatas,
                );
                datasets.push(newDataset);
                secondTicksObj = defaultCountTicksObj; // y軸単位を"回"にする
                labels = this.IS_MEMBER_COUNT_GRAPH
                  ? newDataset.labels
                  : labels;
                break;
              }
              case NOC.MATERIAL.V3.MATERIAL.MEASURE_OP_COUNT_HEATMAP.id: {
                // 操作回数ヒートマップのグラフデータ生成。
                const gadgetMaker = new GadgetMakerOpCountHeatmap(
                  gadgetDatas,
                  this.materials,
                );
                datasets = gadgetMaker.generateDatasets();
                labels = gadgetMaker.generateLabels();
                tmpOptionObj = gadgetMaker.generateOptionObj(tmpOptionObj);
                this.colorbarValueMax = gadgetMaker.getColorbarValueMax();
                break;
              }

              /* 就業時間（第三次デザインから） */
              case NOC.MATERIAL.V3.MATERIAL.COMPARE_MEASURE_LOGING_TIME.id:
                if (
                  measures.some(
                    v =>
                      v.id === NOC.MATERIAL.V3.MATERIAL.MEASURE_LOGING_TIME.id,
                  )
                ) {
                  break;
                }
              case NOC.MATERIAL.V3.MATERIAL.MEASURE_LOGING_TIME.id: {
                // データ系列：ユーザーの場合、グラフ種類に関わらずトータル時間を表示
                if (
                  NOC.OPTION.V2.getValues(
                    this.options,
                    NOC.OPTION.V2.KEY.DATA_SERIES,
                  ) &&
                  gadgetDatas[0]
                ) {
                  // console.log('options', this.options)
                  // console.log('gadgetDatas', gadgetDatas[0])
                  const newlabels = labelsFunction(
                    (gadgetDatas[0].userLabels || []).map(v => ({ label: v })),
                  );
                  // console.log('newlabels', newlabels)
                  labels =
                    this.IS_MULTI && labels.length > 1
                      ? newlabels.concat(labels[labels.length - 1])
                      : newlabels;
                  // console.log('labels', labels)
                  this.pushUserDataSet(
                    datasets,
                    gadgetDatas[0],
                    v => Number(v) / 4,
                    valueFunc,
                    '',
                    getOptionColorType,
                  );
                  ticksObj = defaultTicksObj;
                  break;
                }
                if (
                  this.selectGraphValue === NOC.CHARTS.LIST && // 個人で日毎 or 複数人で日を選択
                  ((!this.IS_MULTI &&
                    !this.IS_GROUP &&
                    this.materials.some(
                      v => v.id === NOC.MATERIAL.V3.MATERIAL.DIMENSION_DATE.id,
                    )) ||
                    (this.IS_MULTI &&
                      !this.IS_GROUP_MULTI &&
                      this.materials.some(
                        v => v.id === NOC.MATERIAL.V3.MATERIAL.TARGET_DATE.id,
                      )))
                ) {
                  // リストで日単位の場合、開始時間と終了時間を表示
                  // const startDataset = this.createDataset(gadgetDatas, '開始時間', NOC.GRAPH.OPTIONS.BCOLOR_BETA[3],
                  // const startDataset = this.createDataset(gadgetDatas, '開始時間', NOC.GRAPH.OPTIONS.BCOLOR_BETA[9],
                  const startDataset = this.createDataset(
                    gadgetDatas,
                    '開始時間',
                    NOC.GRAPH.OPTIONS.BCOLOR_RED_ONLY[0],
                    v => (v.pcStartTime ? timeValueFunc(v.pcStartTime) : '-'),
                    v => String(v),
                  );
                  // const endDataset = this.createDataset(gadgetDatas, '終了時間', NOC.GRAPH.OPTIONS.BCOLOR_BETA[3],
                  // const endDataset = this.createDataset(gadgetDatas, '終了時間', NOC.GRAPH.OPTIONS.BCOLOR_BETA[9],
                  const endDataset = this.createDataset(
                    gadgetDatas,
                    '終了時間',
                    NOC.GRAPH.OPTIONS.BCOLOR_RED_ONLY[0],
                    v => (v.pcEndTime ? timeValueFunc(v.pcEndTime) : '-'),
                    v => String(v),
                  );
                  datasets.push(startDataset);
                  datasets.push(endDataset);
                } else {
                  // 縦棒グラフ等の場合、開始から終了のトータル時間を表示
                  // const newDataset = this.createDataset(gadgetDatas, measureKey, NOC.GRAPH.OPTIONS.BCOLOR_BETA[3],
                  // const newDataset = this.createDataset(gadgetDatas, measureKey, NOC.GRAPH.OPTIONS.BCOLOR_BETA[9],
                  const newDataset = this.createDataset(
                    gadgetDatas,
                    measureKey,
                    NOC.GRAPH.OPTIONS.BCOLOR_RED_ONLY[0],
                    v => Number(v.pcTime || 0) / 4,
                    valueFunc,
                  );
                  this.setLabelsForMulti(
                    newDataset,
                    isAverage,
                    measureKey,
                    gadgetDatas,
                  );
                  datasets.push(newDataset);
                  labels = this.IS_MEMBER_COUNT_GRAPH
                    ? newDataset.labels
                    : labels;
                  // アラートグラフの場合、就業時間は折れ線グラフにする
                  if (
                    this.materials.some(
                      v =>
                        v.id === NOC.MATERIAL.V3.MATERIAL.FLAG_ALERT_GRAPH.id,
                    )
                  ) {
                    newDataset.type = 'line';
                    const linebackcolor = (colors: string[]) =>
                      colors.map((color: string) => this.hex2rgba(color, 1));
                    const bgcolor = linebackcolor(newDataset.backgroundColor);
                    newDataset.borderColor = bgcolor;
                    newDataset.pointBorderColor = bgcolor;
                    newDataset.pointBackgroundColor = '#fff';
                    newDataset.pointRadius = 0;
                    newDataset.fill = false;
                    newDataset.lineTension = 0; // 直線
                    newDataset.order = 0;
                  }
                  newDataset.borderWidth = 1.5;
                }
                ticksObj = defaultTicksObj;
                break;
              }

              /* アプリ */
              case NOC.MATERIAL.V3.MATERIAL.COMPARE_MEASURE_APP.id: // アプリ比較グラフ
                if (
                  !measures.some(
                    v => v.id === NOC.MATERIAL.V3.MATERIAL.MEASURE_APP.id,
                  )
                ) {
                  // メンバー毎のアプリ比較グラフの表示用処理（通常グラフ：任意 ＋ 比較グラフ：アプリ）
                  // ※アプリとアプリ比較の場合は処理不要
                  const gadgetData = gadgetDatas.find(v => v.apps);
                  if (gadgetData) {
                    labels[labels.length - 1] = compareKey;
                    const compareDatasets: any[] = [];
                    this.pushAppDataSet(compareDatasets, gadgetData, valueFunc);
                    for (const dataset of compareDatasets) {
                      // 通常グラフ部分をnullで埋めて最後に比較グラフの値を入れる
                      const compareDataArray = dataset.data;
                      dataset.data = Array(labels.length).fill(null);
                      dataset.data[labels.length - 1] = compareDataArray[0];
                      dataset.backgroundColor = Array(labels.length).fill(
                        dataset.backgroundColor[0],
                      );
                    }
                    datasets = datasets.concat(compareDatasets);
                  }
                }
                break;
              case NOC.MATERIAL.V3.MATERIAL.MEASURE_APP.id: {
                // アプリ通常グラフ
                const newlabels = labelsFunction(
                  (gadgetDatas[0].appLabels || []).map(v => ({ label: v })),
                );
                labels =
                  this.IS_MULTI && labels.length > 1
                    ? newlabels.concat(labels[labels.length - 1])
                    : newlabels;
                this.pushAppDataSet(datasets, gadgetDatas[0], valueFunc);
                ticksObj = defaultTicksObj;
                if (this.selectGraphValue === NOC.CHARTS.DOUGHNUT) {
                  // 円グラフの場合、datasetsとlabelsを変える
                  const newDataset = {
                    label: '',
                    backgroundColor: datasets.map(v => v.backgroundColor[0]),
                    data: datasets.map(v =>
                      v.data.reduce(
                        (sum: number, current: any) => sum + Number(current),
                        0,
                      ),
                    ),
                    tooltip: datasets.map(v =>
                      labels
                        .map((v2, i) =>
                          Number(v.data[i])
                            ? `${v2} (${valueFunc(v.data[i])})`
                            : '',
                        )
                        .filter(v2 => v2),
                    ),
                  };
                  labels = datasets.map(v => v.label);
                  datasets = [newDataset];
                }
                break;
              }

              /* 36協定ガジェット */
              case NOC.MATERIAL.V3.MATERIAL.MEASURE_36_STATUS.id: {
                // 36協定状況リスト
                labels = gadgetDatas.map(v => v.label);
                datasets = [
                  {
                    label: '時間/回数',
                    data: gadgetDatas.map(v => v.workTime),
                  },
                ];
                break;
              }
              case NOC.MATERIAL.V3.MATERIAL.MEASURE_36_VIOLATION.id: {
                // 36協定違反者リスト
                labels = gadgetDatas.map(v => v.label);
                const jobLists = [];
                const departmentLists = [];
                for (const name of labels) {
                  // 職種を取得
                  jobLists.push(
                    NOC.JOB.JOBArray.filter(
                      v =>
                        v.value ===
                        this.users.filter(v2 => v2.name === name)[0].jobID,
                    )[0].text,
                  );
                  // 部署を取得
                  departmentLists.push(
                    this.department.filter(
                      v =>
                        v.departmentID ===
                        this.users.filter(v2 => v2.name === name)[0]
                          .departmentID,
                    )[0].name,
                  );
                }
                datasets = [
                  { label: '部署', data: departmentLists },
                  { label: '職種', data: jobLists },
                  {
                    label: '昨日の残業',
                    data: gadgetDatas.map(v =>
                      v.day!.map(v2 => `${v2.val} ${v2.lbl}`).join('<br>'),
                    ),
                  },
                  {
                    label: '今月の残業',
                    data: gadgetDatas.map(v =>
                      v.month!.map(v2 => `${v2.val} ${v2.lbl}`).join('<br>'),
                    ),
                  },
                  {
                    label: '今年の残業',
                    data: gadgetDatas.map(v =>
                      v.year!.map(v2 => `${v2.val} ${v2.lbl}`).join('<br>'),
                    ),
                  },
                ];
                break;
              }
              /* 禁止アプリ利用者リスト */
              case NOC.MATERIAL.V3.MATERIAL.MEASURE_BANNED_APP_LIST.id: {
                // 禁止アプリ利用者リスト
                labels = gadgetDatas.map(v => v.label);
                const jobLists = [];
                const departmentLists = [];
                for (const name of labels) {
                  // 職種を取得
                  jobLists.push(
                    NOC.JOB.JOBArray.filter(
                      v =>
                        v.value ===
                        this.users.filter(v2 => v2.name === name)[0].jobID,
                    )[0].text,
                  );
                  // 部署を取得
                  departmentLists.push(
                    this.department.filter(
                      v =>
                        v.departmentID ===
                        this.users.filter(v2 => v2.name === name)[0]
                          .departmentID,
                    )[0].name,
                  );
                }
                datasets = [
                  { label: '部署', data: departmentLists },
                  { label: '職種', data: jobLists },
                  {
                    label: 'アラート回数',
                    data: gadgetDatas.map(v => v.count),
                  },
                  {
                    label: '禁止アプリ利用時間',
                    data: gadgetDatas.map(v =>
                      v.apps!.map(v2 => `${v2.lbl}：${v2.val}`).join('<br>'),
                    ),
                  },
                ];
                break;
              }
              /* 禁止アプリグラフ */
              case NOC.MATERIAL.V3.MATERIAL.MEASURE_BANNED_APP.id: {
                // 禁止アプリグラフ
                if (
                  NOC.OPTION.V2.getValues(
                    this.options,
                    NOC.OPTION.V2.KEY.DATA_SERIES,
                  ) &&
                  gadgetDatas[0]
                ) {
                  const newlabels = labelsFunction(
                    (gadgetDatas[0].userLabels || []).map(v => ({ label: v })),
                  );
                  labels =
                    this.IS_MULTI && labels.length > 1
                      ? newlabels.concat(labels[labels.length - 1])
                      : newlabels;
                  this.pushUserDataSet(
                    datasets,
                    gadgetDatas[0],
                    v => Number(v),
                    valueFunc,
                    '',
                    getOptionColorType,
                  );
                  ticksObj = defaultTicksObj;
                  break;
                }
                // const newDataset = this.createDataset(gadgetDatas, measureKey, NOC.GRAPH.OPTIONS.BCOLOR_BETA[30],
                const newDataset = this.createDataset(
                  gadgetDatas,
                  measureKey,
                  NOC.GRAPH.OPTIONS.BCOLOR_GREEN_ONLY[0],
                  v => Number(v.workTime || 0),
                  valueFunc,
                );
                datasets.push(newDataset);
                ticksObj = defaultTicksObj;
                break;
              }
            }
          }

          // 各種データの処理（比較対象） -------------------------------------------------------
          if (
            this.IS_ABLE_TO_COMPARE &&
            this.IS_COMPARE_GRAPH &&
            !this.IS_MULTI
          ) {
            const compareDatasets: any[] = [];
            // 比較グラフの場合はツールチップを２つ表示
            tmpOptionObj.tooltips.mode = 'index';

            // 円グラフ+アプリ+比較グラフの場合の処理
            if (this.IS_COMPARE_GRAPH && this.IS_SELECT_APP_DOUGHNUT) {
              tmpOptionObj.tooltips.mode = 'nearest';
            }

            const compareMeasures2 = NOC.MATERIAL.V3.getCompareMeasures(
              this.materials,
            );
            const findType: any = this.materials.find(
              v => v.domain === 'COMPARE_TYPE',
            );
            for (const measure of compareMeasures2) {
              let measureKey = measure.key;
              if (
                this.selectGraphValue === NOC.CHARTS.LIST &&
                measure.id !==
                  NOC.MATERIAL.V3.MATERIAL.COMPARE_MEASURE_LOGING_TIME.id
              ) {
                measureKey = measureKey.replace('時間', '');
              }
              if (findType.key === '平均') {
                // グラフが平均の場合は'平均'を追記
                measureKey = !this.IS_COMPARE_SAME_SIGLE_MEASURES
                  ? `${measureKey} 平均（${compareKey}）`
                  : `${compareKey} 平均`;
              } else {
                measureKey = !this.IS_COMPARE_SAME_SIGLE_MEASURES
                  ? `${measureKey}（${compareKey}）` // ex. "勤務時間（全社）"
                  : compareKey;
              }

              switch (measure.id) {
                case NOC.MATERIAL.V3.MATERIAL.COMPARE_MEASURE_WORKING_TIME.id: {
                  // 勤務時間
                  // const newDataset = this.createDataset(gadgetDatas, measureKey, NOC.GRAPH.OPTIONS.BCOLOR_BETA[5],
                  // const newDataset = this.createDataset(gadgetDatas, measureKey, NOC.GRAPH.OPTIONS.BCOLOR_BETA[15],
                  const newDataset = this.createDataset(
                    gadgetDatas,
                    measureKey,
                    NOC.GRAPH.OPTIONS.BCOLOR_BLUE_ONLY[1],
                    v =>
                      v.compareValue
                        ? Number(v.compareValue.workTime || 0) / 4
                        : 0,
                    valueFunc,
                  );
                  compareDatasets.push(newDataset);
                  ticksObj = defaultTicksObj;
                  break;
                }
                case NOC.MATERIAL.V3.MATERIAL.COMPARE_MEASURE_OVER_TIME.id: {
                  // 残業時間
                  // const newDataset = this.createDataset(gadgetDatas, measureKey, NOC.GRAPH.OPTIONS.BCOLOR_BETA[6],
                  const newDataset = this.createDataset(
                    gadgetDatas,
                    measureKey,
                    NOC.GRAPH.OPTIONS.BCOLOR_BETA[6],
                    v =>
                      v.compareValue
                        ? Number(v.compareValue.overTime || 0) / 4
                        : 0,
                    valueFunc,
                  );
                  compareDatasets.push(newDataset);
                  ticksObj = defaultTicksObj;
                  break;
                }
                case NOC.MATERIAL.V3.MATERIAL.COMPARE_MEASURE_UNACHIEVED_TIME
                  .id: {
                  // 就業未達成時間
                  const newDataset = this.createDataset(
                    gadgetDatas,
                    measureKey,
                    '#cc6666',
                    v =>
                      v.compareValue
                        ? Number(v.compareValue.workTime || 0) >=
                          Number(v.compareValue.fixedTime || 0)
                          ? 0
                          : (Number(v.compareValue.workTime || 0) -
                              Number(v.compareValue.fixedTime || 0)) /
                            4
                        : 0,
                    valueFunc,
                  );
                  // (v) => (v.compareValue ? (Number(v.compareValue.workTime || 0) - Number(v.compareValue.fixedTime || 0)) / 4 : 0), valueFunc);
                  compareDatasets.push(newDataset);
                  ticksObj = defaultTicksObj;
                  break;
                }
                case NOC.MATERIAL.V3.MATERIAL.COMPARE_MEASURE_INTERVAL_TIME
                  .id: {
                  // インターバル
                  // const newDataset = this.createDataset(gadgetDatas, measureKey, NOC.GRAPH.OPTIONS.BCOLOR_BETA[7],
                  const newDataset = this.createDataset(
                    gadgetDatas,
                    measureKey,
                    NOC.GRAPH.OPTIONS.BCOLOR_BETA[9],
                    v =>
                      v.compareValue
                        ? Number(v.compareValue.intervalTime || 0) / 4
                        : 0,
                    valueFunc,
                  );
                  compareDatasets.push(newDataset);
                  ticksObj = defaultTicksObj;
                  break;
                }
                case NOC.MATERIAL.V3.MATERIAL.COMPARE_MEASURE_LOGING_TIME.id: {
                  // 就業時間（起動時間帯）
                  if (
                    this.selectGraphValue !== NOC.CHARTS.LIST ||
                    !(
                      (!this.IS_MULTI &&
                        !this.IS_GROUP &&
                        this.materials.some(
                          v =>
                            v.id === NOC.MATERIAL.V3.MATERIAL.DIMENSION_DATE.id,
                        )) ||
                      (this.IS_MULTI &&
                        !this.IS_GROUP_MULTI &&
                        this.materials.some(
                          v => v.id === NOC.MATERIAL.V3.MATERIAL.TARGET_DATE.id,
                        ))
                    )
                  ) {
                    // 縦棒グラフ等の場合、開始から終了のトータル時間を表示
                    // const newDataset = this.createDataset(gadgetDatas, measureKey, NOC.GRAPH.OPTIONS.BCOLOR_BETA[8],
                    // const newDataset = this.createDataset(gadgetDatas, measureKey, NOC.GRAPH.OPTIONS.BCOLOR_BETA[24],
                    const newDataset = this.createDataset(
                      gadgetDatas,
                      measureKey,
                      NOC.GRAPH.OPTIONS.BCOLOR_RED_ONLY[1],
                      v =>
                        v.compareValue
                          ? Number(v.compareValue.pcTime || 0) / 4
                          : 0,
                      valueFunc,
                    );
                    compareDatasets.push(newDataset);
                  } else {
                    // リストで日の場合、開始時間と終了時間を表示
                    // const startDataset = this.createDataset(gadgetDatas, `開始時間（${compareKey}）`, NOC.GRAPH.OPTIONS.BCOLOR_BETA[8],
                    // const startDataset = this.createDataset(gadgetDatas, `開始時間（${compareKey}）`, NOC.GRAPH.OPTIONS.BCOLOR_BETA[24],
                    const startDataset = this.createDataset(
                      gadgetDatas,
                      `開始時間（${compareKey}）`,
                      NOC.GRAPH.OPTIONS.BCOLOR_RED_ONLY[0],
                      v =>
                        v.compareValue && v.compareValue.pcStartTime
                          ? timeValueFunc(v.compareValue.pcStartTime)
                          : '-',
                      v => String(v),
                    );
                    // const endDataset = this.createDataset(gadgetDatas, `終了時間（${compareKey}）`, NOC.GRAPH.OPTIONS.BCOLOR_BETA[8],
                    const endDataset = this.createDataset(
                      gadgetDatas,
                      `終了時間（${compareKey}）`,
                      NOC.GRAPH.OPTIONS.BCOLOR_RED_ONLY[0],
                      v =>
                        v.compareValue && v.compareValue.pcEndTime
                          ? timeValueFunc(v.compareValue.pcEndTime)
                          : '-',
                      v => String(v),
                    );
                    compareDatasets.push(startDataset);
                    compareDatasets.push(endDataset);
                  }
                  ticksObj = defaultTicksObj;
                  break;
                }
                case NOC.MATERIAL.V3.MATERIAL.COMPARE_MEASURE_COUNT.id: {
                  // 操作回数
                  // const newDataset = this.createDataset(gadgetDatas, measureKey, NOC.GRAPH.OPTIONS.BCOLOR_BETA[9],
                  const newDataset = this.createDataset(
                    gadgetDatas,
                    measureKey,
                    NOC.GRAPH.OPTIONS.BCOLOR_BETA[5],
                    v =>
                      v.compareValue ? Number(v.compareValue.count || 0) : 0,
                    countValueFunc,
                  );
                  if (
                    this.selectGraphValue === NOC.CHARTS.HORIZONTALBAR ||
                    this.selectGraphValue === NOC.CHARTS.STACKED_HORIZONTALBAR
                  ) {
                    newDataset.xAxisID = 'axis-count';
                  } else {
                    newDataset.yAxisID = 'axis-count';
                  }
                  compareDatasets.push(newDataset);
                  secondTicksObj = defaultCountTicksObj;
                  break;
                }
                case NOC.MATERIAL.V3.MATERIAL.COMPARE_MEASURE_APP.id: {
                  // アプリ
                  const gadgetData = gadgetDatas.find(v => v.compareValue);
                  if (gadgetData) {
                    this.pushAppDataSet(
                      compareDatasets,
                      gadgetData.compareValue!,
                      valueFunc,
                      compareKey,
                    );
                  }
                  ticksObj = defaultTicksObj;
                  break;
                }
                case NOC.MATERIAL.V3.MATERIAL.COMPARE_MEASURE_BANNED_APP.id: {
                  // 禁止アプリ
                  const backgroundColor = [];
                  const data = [];
                  for (const gadgetData of gadgetDatas) {
                    const compareValue = gadgetData.compareValue;
                    backgroundColor.push(NOC.GRAPH.OPTIONS.BCOLOR_GREEN_ONLY[1]);
                    data.push(compareValue ? compareValue.workTime : 0);
                  }
                  const appDataset = {
                    label: measureKey,
                    backgroundColor,
                    data,
                    formatter: null,
                    order: 1,
                  };
                  compareDatasets.push(appDataset);
                  break;
                }
              }
            }
            if (this.selectGraphValue !== NOC.CHARTS.DOUGHNUT) {
              for (const dataset of compareDatasets) {
                dataset.type = 'line'; // 比較グラフは折れ線にする
                const linebackcolor = (colors: string[]) =>
                  colors.map((color: string) => this.hex2rgba(color, 1));
                const bgcolor = linebackcolor(dataset.backgroundColor);
                dataset.borderWidth = 1.5;
                dataset.borderColor = bgcolor;
                dataset.pointBorderColor = bgcolor;
                dataset.pointBackgroundColor = bgcolor;
                dataset.pointRadius = 0;
                dataset.fill = false;
                dataset.lineTension = 0; // 直線
                dataset.order = 0;
                tmpOptionObj.tooltips.itemSort = (
                  a: any,
                  b: any,
                  data: any,
                ) => {
                  return a.datasetIndex - b.datasetIndex;
                };
              }
            }

            if (this.IS_SELECT_APP_DOUGHNUT && this.IS_COMPARE_GRAPH) {
              // 円グラフ+アプリ+比較グラフの場合の処理
              for (const compareDataset of compareDatasets) {
                labels = labels.concat(compareDataset.label); // 凡例を追加
                compareDataset.labels = gadgetDatas[0].appLabels; // 円グラフを複数表示する際は時間をdataset.labelsへ
              }
            }
            datasets = datasets.concat(compareDatasets);
          }

          // y軸設定
          let axesProp = '';
          switch (this.selectGraphValue) {
            case NOC.CHARTS.BAR:
            case NOC.CHARTS.STACKED_BAR:
            case NOC.CHARTS.LINE:
              axesProp = 'yAxes';
            // breakなし
            case NOC.CHARTS.HORIZONTALBAR:
            case NOC.CHARTS.STACKED_HORIZONTALBAR:
              axesProp = axesProp || 'xAxes';
              if (!ticksObj && secondTicksObj) {
                ticksObj = secondTicksObj;
                secondTicksObj = null;
                tmpOptionObj.scales[axesProp][0].id = 'axis-count';
              }
              tmpOptionObj.scales[axesProp][0].ticks = ticksObj;
              if (secondTicksObj) {
                const secondAxis = JSON.parse(
                  JSON.stringify(tmpOptionObj.scales[axesProp][0]),
                );
                tmpOptionObj.scales[axesProp].push(secondAxis);
                tmpOptionObj.scales[axesProp][1].ticks = secondTicksObj;
                tmpOptionObj.scales[axesProp][1].id = 'axis-count';
                tmpOptionObj.scales[axesProp][1].position =
                  axesProp === 'yAxes' ? 'right' : 'top';
                tmpOptionObj.scales[axesProp][1].type = 'linear';
                tmpOptionObj.scales[
                  axesProp
                ][1].gridLines.drawOnChartArea = false;
              }
              break;
          }
        }

        // datasets確定後の処理
        // データが全て0の部分は非表示にする ※中間は消さない
        // if (!this.IS_MULTI && this.selectGraphValue !== NOC.CHARTS.LIST) {
        //   const labelsLength = labels.length;
        //   const deleteIndexes: boolean[] = new Array(labelsLength);
        //   for (let i = 0; i < labelsLength; i++) {
        //     deleteIndexes[i] = !datasets.some((dataset) => (Number(dataset.data[i]))); // 0判定
        //   }
        //   const firstIndex = deleteIndexes.indexOf(false);
        //   const lastIndex = deleteIndexes.lastIndexOf(false) + 1;
        //   if (0 < firstIndex || lastIndex < labelsLength) {
        //     for (const dataset of datasets) {
        //       dataset.data = dataset.data.slice(firstIndex, lastIndex);
        //       dataset.backgroundColor = dataset.backgroundColor.slice(firstIndex, lastIndex);
        //       if (dataset.tooltip) {
        //         dataset.tooltip = dataset.tooltip.slice(firstIndex, lastIndex);
        //       }
        //     }
        //     labels = labels.slice(firstIndex, lastIndex);
        //   }
        // }

        // options処理
        // todo:hideen optionsへ以降
        switch (this.selectGraphValue) {
          case NOC.CHARTS.LINE: {
            const linebackcolor = (colors: string[]) =>
              colors.map((color: string) => this.hex2rgba(color, 1));
            for (const dataset of datasets) {
              const bgcolor = linebackcolor(dataset.backgroundColor);
              dataset.borderColor = bgcolor;
              dataset.pointBorderColor = bgcolor;
              dataset.pointBackgroundColor = bgcolor;
              dataset.pointRadius = 0;
              dataset.fill = false;
              dataset.lineTension = 0; // 直線
              tmpOptionObj.tooltips.intersect = false;
              tmpOptionObj.tooltips.mode = 'index';
            }
            break;
          }
          case NOC.CHARTS.RADAR: {
            const linebackcolor = (colors: string[]) =>
              colors.map((color: string) => this.hex2rgba(color, 1));
            for (const dataset of datasets) {
              const bgcolor = linebackcolor(dataset.backgroundColor);
              dataset.borderColor = bgcolor;
              dataset.backgroundColor = bgcolor;
              dataset.pointBorderColor = bgcolor;
              dataset.pointBackgroundColor = '#fff';
              dataset.pointRadius = 0;
            }
            break;
          }
          case NOC.CHARTS.DOUGHNUT:
            // 円グラフのデータラベル設定
            const appGraphCheck = this.materials.some(
              v => v.id === 24 || v.id === 41,
            );
            tmpOptionObj.plugins.datalabels.labels.name.formatter = !appGraphCheck
              ? datalabelNameFormatter
              : appDatalabelNameFormatter;
            // tmpOptionObj.plugins.datalabels.labels.name.formatter = datalabelNameFormatter;
            tmpOptionObj.plugins.datalabels.labels.value.formatter = (
              value: any,
              context: any,
            ) => {
              const val = datalabelValueFormatter(value, context);
              let label = '';
              if (val) {
                if (this.IS_MEMBER_COUNT_GRAPH) {
                  // 複数人円グラフ
                  if (this.IS_GROUP_MULTI) {
                    label = `${value}グループ`;
                  } else if (this.IS_DEPARTMENT_MULTI) {
                    label = `${value}部署`;
                  } else {
                    label = `${value}名`;
                  }
                } else if (
                  context.dataset.label.indexOf(
                    NOC.MATERIAL.V3.MATERIAL.MEASURE_COUNT.key,
                  ) >= 0
                ) {
                  // 操作回数
                  label = countValueFunc(value);
                } else {
                  // "h" or "m"
                  label = valueFunc(value);
                }
              }
              return label;
            };
            break;
        }

        // 最小値オプション
        if (
          NOC.OPTION.V2.getValues(this.options, NOC.OPTION.V2.KEY.MIN_VALUE)
        ) {
          let axes = tmpOptionObj.scales.yAxes;
          if (
            this.selectGraphValue === NOC.CHARTS.HORIZONTALBAR ||
            this.selectGraphValue === NOC.CHARTS.STACKED_HORIZONTALBAR
          ) {
            axes = tmpOptionObj.scales.xAxes;
          }
          for (const axe of axes) {
            axe.ticks.beginAtZero = true;
            axe.ticks.padding = 10;
          }
        }

        // 凡例オプション
        tmpOptionObj.legend.display = false; // 凡例カスタマイズのためデフォルト凡例は非表示
        this.isDisplayLegend = NOC.OPTION.V2.getValues(
          this.options,
          NOC.OPTION.V2.KEY.LEGEND,
        );

        // ツールチップ
        tmpOptionObj.tooltips.custom = this.customToolTips;
        if (
          this.materials.some(
            v => v.id === NOC.MATERIAL.V3.MATERIAL.MEASURE_OP_COUNT_HEATMAP.id,
          )
        ) {
          // 操作回数ヒートマップの場合 GadgetMaker.generateOptionObj()でツールチップ設定を行うためここでは何もしない。
        } else {
          // 上記以外
          tmpOptionObj.tooltips.callbacks.title = this.tooltipTitle;
          tmpOptionObj.tooltips.callbacks.label = this.tooltipLabel;
          tmpOptionObj.tooltips.callbacks.footer = this.tooltipFooter;
          tmpOptionObj.tooltips.callbacks.labelColor = (
            tooltipItem: any,
            chart: any,
          ) => ({
            backgroundColor:
              chart.config.data.datasets[tooltipItem.datasetIndex]
                .backgroundColor[tooltipItem.index],
            borderColor: '#fff',
          });
        }

        this.dataObj = {
          labels,
          datasets,
        };
        this.optionsObj = tmpOptionObj;
      } catch (e) {
        console.error(e);
        this.frameData.error = true;
      }
    },
    setOptions() {
      // options成型
      this.optionItems = NOC.OPTION.V2.createChoices(
        this.selectGraphValue,
        this.materials,
      );
      // 特殊条件
      // メジャーが1個の場合のみカラー、データ系列選択可能
      if (NOC.MATERIAL.V3.getMeasures(this.materials).length !== 1) {
        this.optionItems = this.optionItems.filter(
          v =>
            v.key !== NOC.OPTION.V2.KEY.COLOR &&
            v.key !== NOC.OPTION.V2.KEY.DATA_SERIES,
        );
      }

      // カラーオプション(比較元のデータが１つ+比較先のデータが１つ+その二つのデータが同じ時はオプション設定カラーを選択できるようにする)
      const getCompareMeasures = NOC.MATERIAL.V3.getCompareMeasures(
        this.materials,
      );
      const getMeasures = NOC.MATERIAL.V3.getMeasures(this.materials);
      const getMeasureKey = getMeasures.find(v => v.key);
      const getCompareMeasureKey = getCompareMeasures.find(v => v.key);
      if (this.IS_COMPARE_GRAPH) {
        if (
          getMeasures.length === 1 &&
          getCompareMeasures.length === 1 &&
          this.IS_MULTI &&
          getMeasureKey &&
          getCompareMeasureKey &&
          getMeasureKey.key === getCompareMeasureKey.key
        ) {
          this.optionItems = this.optionItems;
        } else {
          this.optionItems = this.optionItems.filter(v => v.key !== 'color');
        }
      }

      // アプリグラフの場合はオプションのカラ-切り替えはなし
      if (
        this.materials.some(
          v => v.id === NOC.MATERIAL.V3.MATERIAL.MEASURE_APP.id,
        )
      ) {
        this.optionItems = this.optionItems.filter(v => v.key !== 'color');
      }

      // 比較グラフ、アプリグラフの場合は
      // ・円グラフオプションなし（時間表示とする）
      // ・データ系列なし（データ表示とする）
      if (
        NOC.MATERIAL.V3.getCompareTargets(this.materials).length > 0 ||
        NOC.MATERIAL.V3.getCompareType(this.materials) ||
        NOC.MATERIAL.V3.getCompareMeasures(this.materials).length > 0 ||
        this.materials.some(
          v => v.id === NOC.MATERIAL.V3.MATERIAL.MEASURE_APP.id,
        )
      ) {
        this.optionItems = this.optionItems.filter(
          v =>
            v.key !== NOC.OPTION.V2.KEY.MULTI_DOUGHNUT &&
            v.key !== NOC.OPTION.V2.KEY.DATA_SERIES,
        );
      }

      // 以下の場合はデータ系列なし（データ表示とする）
      // ・平均グラフ
      // ・ターゲットが日で、メジャーが残業時間またはインターバル
      // if (this.materials.some((v) => v.id === NOC.MATERIAL.V3.MATERIAL.TYPE_AVERAGE.id) ||
      //     (this.materials.some((v) => v.id === NOC.MATERIAL.V3.MATERIAL.TARGET_DATE.id) &&
      //       this.materials.some((v) =>
      //         v.id === NOC.MATERIAL.V3.MATERIAL.MEASURE_OVER_TIME.id ||
      //         v.id === NOC.MATERIAL.V3.MATERIAL.MEASURE_INTERVAL_TIME.id))) {
      //   this.optionItems = this.optionItems.filter((v) => v.key !== NOC.OPTION.V2.KEY.DATA_SERIES);
      // }

      // alert(NOC.MATERIAL.V3.MATERIAL.TYPE_AVERAGE.id)
      if (
        (this.materials.some(
          v => v.id === NOC.MATERIAL.V3.MATERIAL.TYPE_AVERAGE.id,
        ) &&
          this.materials.some(
            v => v.id === NOC.MATERIAL.V3.MATERIAL.TARGET_ALL.id,
          )) ||
        (this.materials.some(
          v => v.id === NOC.MATERIAL.V3.MATERIAL.TYPE_SUM.id,
        ) &&
          this.IS_DEPARTMENT_MULTI) ||
        (this.materials.some(
          v => v.id === NOC.MATERIAL.V3.MATERIAL.TARGET_DATE.id,
        ) &&
          this.materials.some(
            v =>
              v.id === NOC.MATERIAL.V3.MATERIAL.MEASURE_OVER_TIME.id ||
              v.id === NOC.MATERIAL.V3.MATERIAL.MEASURE_INTERVAL_TIME.id,
          ))
      ) {
        this.optionItems = this.optionItems.filter(
          v => v.key !== NOC.OPTION.V2.KEY.DATA_SERIES,
        );
      }

      // 旧グラフからの引継ぎ表示時は時間表示、それ以外は人数表示をデフォルトとする
      if (
        this.optionItems.some(
          v => v.key === NOC.OPTION.V2.KEY.MULTI_DOUGHNUT,
        ) &&
        this.materials.some(
          v =>
            v.id === NOC.MATERIAL.V3.MATERIAL.TARGET_ALL.id ||
            v.id === NOC.MATERIAL.V3.MATERIAL.TARGET_GROUP_MULTI.id,
        ) &&
        !this.materials.some(
          v =>
            v.id === NOC.MATERIAL.V3.MATERIAL.FLAG_GROUP_MEMBER.id ||
            v.id === NOC.MATERIAL.V3.MATERIAL.FLAG_MULTI_MEMBER.id,
        )
      ) {
        const newMultiDoughnut = NOC.OPTION.V2.changeProps(
          NOC.OPTION.V2.OPTION.MULTI_DOUGHNUT,
          opt => {
            opt.default = true;
          },
        );
        this.optionItems = this.optionItems.filter(
          v => v.key !== NOC.OPTION.V2.KEY.MULTI_DOUGHNUT,
        );
        this.optionItems.push(newMultiDoughnut);
      }

      this.options = NOC.OPTION.V2.createOptions(
        this.options,
        this.optionItems,
      );
    },
    hex2rgba(hex: string, alpha = 1) {
      // ロングバージョンの場合（例：#FF0000）
      if (!hex) {
        return null;
      }
      let r = hex.match(/^#([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i);
      let c = null;
      if (r) {
        c = r.slice(1, 4).map(x => parseInt(x, 16));
      }
      // ショートバージョンの場合（例：#F00）
      r = hex.match(/^#([0-9a-f])([0-9a-f])([0-9a-f])$/i);
      if (r) {
        c = r.slice(1, 4).map(x => 0x11 * parseInt(x, 16));
      }
      // 該当しない場合は、nullを返す.
      if (!c) {
        return null;
      }
      return `rgba(${c[0]}, ${c[1]}, ${c[2]}, ${alpha})`;
    },
    async testBase64() {
      const mycanvas = (this.$refs.chartdom as any).$refs.canvas;
      // PDFで透過PNGを表示すると黒い縁取りがついてしまうため
      // グラフ背景を白で塗りつぶして不透過にする
      const dummyCanvas = document.createElement('canvas');
      dummyCanvas.width = mycanvas.width;
      dummyCanvas.height = mycanvas.height;
      const dummyContext = dummyCanvas.getContext('2d')!;
      dummyContext.fillStyle = 'rgb(255, 255, 255)';
      dummyContext.fillRect(0, 0, mycanvas.width, mycanvas.height);
      dummyContext.drawImage(mycanvas, 0, 0);
      const dataURL = dummyCanvas.toDataURL();

      const uri = dataURL.replace(/^.*,/, '');
      let legendList: Array<{ value: string; bgcolor: string }> = [];
      if (this.isDisplayLegend) {
        legendList = this.legendList.map(v => ({
          value: v.value,
          bgcolor: v.bgcolor,
        }));
      }
      const api = new API();
      await api.post<any, any>('alert/pdf', {
        title: 'タイトル',
        date: '2022/01/01',
        graphList: [
          {
            text: 'テキスト',
            url: uri,
            legendList,
          },
        ],
      });
    },
    getRatio(): number {
      if (!this || !this.$refs || !this.$refs.chartdom) {
        return 1;
      }
      const mycanvas = (this.$refs.chartdom as any).$refs.canvas;
      const position = mycanvas.getBoundingClientRect();
      const styleWidth = mycanvas.style.width;
      return position.width / styleWidth.substr(0, styleWidth.length - 2);
    },
    customToolTips(tooltipModel: any) {
      // ツールチップイベント
      const canvas = (this.$refs.chartdom as any).$refs.canvas;
      const position = canvas.getBoundingClientRect();
      this.tooltip = { tooltipModel, ratio: this.ratio, position };
      this.$emit('setTooltip', this.tooltip);
    },
    changeLegend(newValue: string) {
      // 凡例表示
      this.ratio = this.getRatio();
      const datasets = (this.dataObj as any).datasets;
      if (this.IS_SELECT_APP_DOUGHNUT || this.IS_MEMBER_COUNT_GRAPH) {
        const labels = (this.dataObj as any).labels;
        this.legendList = labels.map((v: any, index: number) => ({
          index,
          bgcolor: datasets[0].backgroundColor[index],
          value: v,
          hidden: false,
        }));
        if (this.IS_COMPARE_GRAPH && datasets.length > 1) {
          // datasetsが1以上だった場合、凡例のカラーを追加
          for (let i = 0; i < datasets.length; i++) {
            if (
              this.legendList[
                this.legendList.length - (datasets.length - 1) + i
              ]
            ) {
              this.legendList[
                this.legendList.length - (datasets.length - 1) + i
              ].bgcolor = datasets[1 + i].backgroundColor[0];
            }
          }
        }
      } else {
        this.legendList = datasets.map((v: any, index: number) => ({
          index,
          bgcolor: v.backgroundColor[0],
          value: v.label,
          hidden: false,
        }));
      }
      this.$emit('setLegend', this.legendList);
    },
    onClickLegend(idx: number) {
      // 凡例クリック時、該当データを非表示にする
      const chart = (this.$refs.chartdom as any).$data._chart;
      let meta =
        this.IS_SELECT_APP_DOUGHNUT || this.IS_MEMBER_COUNT_GRAPH
          ? chart.getDatasetMeta(0).data[idx]
          : chart.getDatasetMeta(idx);
      if (meta === undefined) {
        const num = idx - chart.getDatasetMeta(0).data.length + 1;
        meta = chart.getDatasetMeta(num);
      }
      meta.hidden = !meta.hidden;
      chart.update();
      this.legendList[idx].hidden = !this.legendList[idx].hidden;
    },
    onMouseMoveGraphParent(event: any) {
      // ダッシュボードのちらつき対策：
      // ツールチップを出している間はイベントをグリッドに伝えない
      // ドラッグアンドドロップなら伝える
      if (
        event.buttons < 1 &&
        this.tooltip.tooltipModel &&
        this.tooltip.tooltipModel.opacity > 0
      ) {
        event.stopImmediatePropagation();
      }
    },

    /* 以下はグラフ種類ごとのデータ加工処理 */
    tooltipTitle(tooltipItem: any[], data: any): string[] {
      // ツールチップ先頭の太字部分
      let title: any = [];
      const findKeys: any = this.materials.filter(v => v.domain === 'MEASURE');
      if (
        NOC.OPTION.V2.getValues(this.options, NOC.OPTION.V2.KEY.DATA_SERIES)
      ) {
        const findType: any = this.materials.find(v => v.domain === 'TYPE');
        // データ系列：ユーザー
        const ofStr =
          findType && findType.key === '平均グラフ' ? 'の平均' : 'の';
        title = tooltipItem[0].label + ofStr + findKeys[0].key;
      } else {
        // データ系列：データ
        title = tooltipItem[0].label;
        if (this.IS_COMPARE_SAME_SIGLE_MEASURES && !this.IS_MULTI) {
          // 比較元と比較先が同じMEASUREの場合はタイトルにkey記載
          title = tooltipItem[0].label + 'の' + findKeys[0].key;
        }
      }

      switch (this.selectGraphValue) {
        case NOC.CHARTS.DOUGHNUT:
        case NOC.CHARTS.PIE:
        case NOC.CHARTS.RADAR:
          title =
            this.IS_SELECT_APP_DOUGHNUT || this.IS_MEMBER_COUNT_GRAPH
              ? []
              : data.labels[tooltipItem[0].index];
          break;
      }
      return title;
    },
    tooltipLabel(tooltipItem: any, data: any): string {
      // ツールチップの「XXX：99.99h」部分
      let label = data.datasets[tooltipItem.datasetIndex].label;
      if (
        (this.IS_SELECT_APP_DOUGHNUT && !this.IS_COMPARE_GRAPH) ||
        this.IS_MEMBER_COUNT_GRAPH
      ) {
        label = data.labels[tooltipItem.index];
      } else if (
        this.IS_MULTI &&
        !NOC.OPTION.V2.getValues(this.options, NOC.OPTION.V2.KEY.DATA_SERIES) &&
        !this.materials.some(v => v.id === 24) &&
        !this.materials.some(v => v.id === 41)
      ) {
        label =
          data.datasets[tooltipItem.datasetIndex].labels[tooltipItem.index];
      } else if (this.IS_SELECT_APP_DOUGHNUT && this.IS_COMPARE_GRAPH) {
        label = data.datasets[tooltipItem.datasetIndex].label;
        if (!label) {
          label = data.labels[tooltipItem.index];
        }
      }
      label = label ? `${label}：` : '';
      let isMembers = false;
      let isDisplayNone = false;
      let value = tooltipItem.value;
      switch (this.selectGraphValue) {
        case NOC.CHARTS.LINE:
          // アプリの折れ線グラフなら0hの内訳を削除
          isDisplayNone = value === 0 && this.materials.some(v => v.id === 24);
          break;
        case NOC.CHARTS.PIE:
        case NOC.CHARTS.DOUGHNUT:
          // 集計・平均グラフの複数人の円グラフは「99h：9名」表示
          value =
            data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
          isMembers = this.IS_MEMBER_COUNT_GRAPH;
          break;
      }
      if (isDisplayNone) {
        return '';
      }
      if (isMembers) {
        if (this.IS_GROUP_MULTI) {
          label = `${label}${value}グループ`;
        } else if (this.IS_DEPARTMENT_MULTI) {
          label = `${label}${value}部署`;
        } else {
          label = `${label}${value}名`;
        }
      } else {
        // 操作回数なら"回"にする
        // console.log(tooltipItem, data);
        const measure = data.datasets[tooltipItem.datasetIndex].label;
        if (
          measure.indexOf(NOC.MATERIAL.V3.MATERIAL.MEASURE_COUNT.key) >= 0 ||
          (NOC.OPTION.V2.getValues(
            this.options,
            NOC.OPTION.V2.KEY.DATA_SERIES,
          ) &&
            this.materials.some(
              v => v.id === NOC.MATERIAL.V3.MATERIAL.MEASURE_COUNT.id,
            ))
        ) {
          label = `${label}${value}回`;
        } else {
          label = this.materials.some(
            v => v.id === NOC.MATERIAL.V3.MATERIAL.DIMENSION_HOUR.id,
          )
            ? `${label}${Math.round(value * 6000) / 100}m`
            : `${label}${Math.round(value * 100) / 100}h`;
        }
      }
      return label;
    },
    tooltipFooter(tooltipItem: any[], data: any): string[] {
      // 「XXX (99.99h)」部分
      // 複数人・アプリのドーナッツ
      let footer = [];
      if (
        this.IS_SELECT_APP_DOUGHNUT ||
        this.IS_MEMBER_COUNT_GRAPH ||
        this.bannedAppsValue
      ) {
        // アプリグラフ実装時点でtooltipItem.lengthは1まで
        footer =
          data.datasets[tooltipItem[0].datasetIndex].tooltip[
            tooltipItem[0].index
          ];
      }
      return footer || [];
    },
    pushAppDataSet(
      datasets: any[],
      gadgetData: IGraphData,
      valueFunc: (v: number | string) => string,
      compareKey?: string,
    ) {
      const appList = gadgetData.apps || [];
      const compareLabel = compareKey ? `（${compareKey}）` : '';
      // アプリ毎にdata配列作成してpush
      for (let i = 0; i < appList.length; i++) {
        const bgcolor =
          appList[i].lbl === 'その他'
            ? NOC.GRAPH.OPTIONS.BCOLOR_BETA[
                NOC.GRAPH.OPTIONS.BCOLOR_BETA.length - 1
              ] // その他はグレー
            : NOC.GRAPH.OPTIONS.BCOLOR_BETA[
                i % (NOC.GRAPH.OPTIONS.BCOLOR_BETA.length - 1)
              ]; // グレー以外
        const appDataset = {
          label: `${appList[i].lbl}${compareLabel}`,
          backgroundColor: appList[i].val.map(() => bgcolor),
          data: appList[i].val,
          formatter:
            this.selectGraphValue === NOC.CHARTS.LIST ? valueFunc : null,
          tooltip: appList[i].val.map(_ => [] as string[]),
          // tooltip: appList[i].val.map((_) => ['xxx (xxxh)'] as string[]), // 動作確認用
          order: 1,
          labels: appList,
        };
        // 禁止アプリの情報をツールチップ表示
        const innerSeries = appList[i].innerSeries;
        if (innerSeries) {
          for (const app of innerSeries) {
            const valList = app.val;
            for (let j = 0; j < valList.length; j++) {
              if (Number(valList[j])) {
                appDataset.tooltip[j].push(
                  `${app.lbl} (${valueFunc(valList[j])})`,
                );
              }
            }
          }
        }
        datasets.push(appDataset);
      }
    },
    pushUserDataSet(
      datasets: any[],
      gadgetData: IGraphData,
      dataFunc: (v: number | string) => number | string,
      valueFunc: (v: number | string) => string,
      compareKey?: string,
      optionColorType?: string,
    ) {
      const userList = gadgetData.users || [];
      const compareLabel = compareKey ? `（${compareKey}）` : '';
      // ユーザー毎にdata配列作成してpush
      for (let i = 0; i < userList.length; i++) {
        const data = userList[i].val.map(v => dataFunc(v));
        const appDataset = {
          label: `${userList[i].lbl}${compareLabel}`,
          backgroundColor: userList[i].val.map(() =>
            optionColorType === '2' // パターン2
              ? NOC.GRAPH.OPTIONS.BCOLOR_BETA[
                  i % NOC.GRAPH.OPTIONS.BCOLOR_BETA.length
                ] // カラフル
              : optionColorType === '3' // パターン3
              ? NOC.GRAPH.OPTIONS.BCOLOR_RED_ONLY[
                  i % NOC.GRAPH.OPTIONS.BCOLOR_BETA.length
                ] // 赤系
              : optionColorType === '4' // パターン4
              ? NOC.GRAPH.OPTIONS.BCOLOR_BLUE_ONLY[
                  i % NOC.GRAPH.OPTIONS.BCOLOR_BETA.length
                ] // 青系
              : optionColorType === '5' // パターン5
              ? NOC.GRAPH.OPTIONS.BCOLOR_GREEN_ONLY[
                  i % NOC.GRAPH.OPTIONS.BCOLOR_BETA.length
                ] // 緑系
              : NOC.GRAPH.OPTIONS.BCOLOR_BLUE_ONLY[
                  i % NOC.GRAPH.OPTIONS.BCOLOR_BETA.length
                ],
          ), // パターン1、単色
          // : NOC.GRAPH.OPTIONS.BCOLOR_BETA[i % (NOC.GRAPH.OPTIONS.BCOLOR_BETA.length - 1)]), // パターン1、単色
          // backgroundColor: userList[i].val.map(() => NOC.GRAPH.OPTIONS.BCOLOR_BETA[i % (NOC.GRAPH.OPTIONS.BCOLOR_BETA.length - 1)]),
          // backgroundColor: userList[i].val.map(() => '#3368EE'),
          // backgroundColor: userList[i].val.map(() => NOC.GRAPH.OPTIONS.BCOLOR_BLUE[i]),
          data,
          formatter:
            this.selectGraphValue === NOC.CHARTS.LIST ? valueFunc : null,
          order: 1,
        };
        datasets.push(appDataset);
      }
    },
    createDataset(
      gadgetDatas: IGraphData[],
      measureKey: string,
      bgcolor: string,
      dataFunc: (v: IGraphData) => number | string,
      valueFunc: (v: number | string) => string,
    ) {
      let myGadgetDatas = gadgetDatas;
      const isDoughnut = this.selectGraphValue === NOC.CHARTS.DOUGHNUT;
      if (
        this.IS_COMPARE_GRAPH &&
        this.IS_MULTI &&
        myGadgetDatas.length > 0 &&
        myGadgetDatas[0].apps
      ) {
        // 複数人比較グラフの場合はアプリの部分をダミーデータで埋める
        myGadgetDatas = Array(myGadgetDatas[0].appLabels!.length)
          .fill({ label: '' } as IGraphData)
          .concat(myGadgetDatas.slice(1, myGadgetDatas.length));
      }
      let backgroundColor: string[];
      const getOptionColorType = NOC.OPTION.V2.getValues(
        this.options,
        NOC.OPTION.V2.KEY.COLOR,
      );
      const getDataSeriesStatus = NOC.OPTION.V2.getValues(
        this.options,
        NOC.OPTION.V2.KEY.DATA_SERIES,
      );
      if (getOptionColorType === '2' && !getDataSeriesStatus) {
        backgroundColor = myGadgetDatas.map(
          (_, i) => NOC.GRAPH.OPTIONS.BCOLOR_BLUE_ONLY[0],
        ); // 青
      } else if (getOptionColorType === '3' && !getDataSeriesStatus) {
        backgroundColor = myGadgetDatas.map(
          (_, i) => NOC.GRAPH.OPTIONS.BCOLOR_RED_ONLY[0],
        ); // 赤
      } else if (getOptionColorType === '4' && !getDataSeriesStatus) {
        backgroundColor = myGadgetDatas.map(
          (_, i) => NOC.GRAPH.OPTIONS.BCOLOR_BLUE_ONLY[0],
        ); // 青
      } else if (getOptionColorType === '5' && !getDataSeriesStatus) {
        backgroundColor = myGadgetDatas.map(
          (_, i) => NOC.GRAPH.OPTIONS.BCOLOR_GREEN_ONLY[0],
        ); // 緑
      } else if (getOptionColorType === false) {
        backgroundColor = myGadgetDatas.map(_ => bgcolor);
      } else if (getOptionColorType === true) {
        backgroundColor = myGadgetDatas.map(
          (_, i) => NOC.GRAPH.OPTIONS.BCOLOR_BLUE_ONLY[0],
        ); // 青
      } else {
        backgroundColor = myGadgetDatas.map(_ => bgcolor);
      }
      // if (NOC.OPTION.V2.getValues(this.options, NOC.OPTION.V2.KEY.COLOR)) {
      //   backgroundColor = myGadgetDatas.map((_, i) => (NOC.GRAPH.OPTIONS.BCOLOR_BETA[i % NOC.GRAPH.OPTIONS.BCOLOR_BETA.length]));
      // } else {
      //   backgroundColor = myGadgetDatas.map((_) => (bgcolor));
      // }
      const dataset = {
        type: '',
        label: measureKey,
        backgroundColor,
        data: myGadgetDatas.map(dataFunc),
        formatter: this.selectGraphValue === NOC.CHARTS.LIST ? valueFunc : null,
        order: 1,
        tooltip: [] as string[][],
        labels: [] as string[],
      };
      const isMeasureCount =
        measureKey === NOC.MATERIAL.V3.MATERIAL.MEASURE_COUNT.key;
      const targets = NOC.MATERIAL.V3.getTargets(this.materials);
      const isAverage = this.materials.some(
        v => v.id === NOC.MATERIAL.V3.MATERIAL.TYPE_AVERAGE.id,
      );
      // 集計、平均グラフ
      if (isDoughnut && this.IS_MEMBER_COUNT_GRAPH) {
        // 「xxh：xx名」のドーナッツグラフ
        let round = isMeasureCount ? 10000 : 1;
        for (const target of targets) {
          // ・時間表示・・・　年：100h毎、月：10h毎、日：1h毎
          // ・操作回数・・・
          //   ・集計グラフ 年：100万毎、月：10万毎、日：1万毎
          //   ・平均グラフ 年：10万毎、月：1万毎、日：1000毎
          switch (target.id) {
            case NOC.MATERIAL.V3.MATERIAL.TARGET_YEAR.id:
              if (isMeasureCount && !isAverage) {
                round = 1000000;
              } else if (isMeasureCount && isAverage) {
                round = 100000;
              } else {
                round = 100;
              }
              break;
            case NOC.MATERIAL.V3.MATERIAL.TARGET_MONTH.id:
              if (isMeasureCount && !isAverage) {
                round = 100000;
              } else if (isMeasureCount && isAverage) {
                round = 10000;
              } else {
                round = 10;
              }
              break;
          }
        }
        let rangeList: Array<{ range: number; list: IGraphData[] }> = [];
        for (const data of myGadgetDatas) {
          const range = Math.floor(Number(dataFunc(data)) / round) * round;
          let rangeData = rangeList.find(v => v.range === range);
          if (!rangeData) {
            rangeData = { range, list: [] };
            rangeList.push(rangeData);
          }
          rangeData.list.push(data);
        }
        // 丸め値のリスト（昇順）を基にdatasets上書き
        rangeList = rangeList.sort((a, b) => a.range - b.range);
        dataset.labels = rangeList.map(v => valueFunc(v.range));
        const mygetOptionColorType = NOC.OPTION.V2.getValues(
          this.options,
          NOC.OPTION.V2.KEY.COLOR,
        );
        // dataset.backgroundColor = rangeList.map((_, i) => (NOC.GRAPH.OPTIONS.BCOLOR_BETA[i % NOC.GRAPH.OPTIONS.BCOLOR_BETA.length]));
        dataset.backgroundColor = rangeList.map((_, i) =>
          mygetOptionColorType === '2'
            ? NOC.GRAPH.OPTIONS.BCOLOR_BETA[0 + i] // カラフル
            : mygetOptionColorType === '3'
            ? NOC.GRAPH.OPTIONS.BCOLOR_RED_ONLY[0 + i] // 赤系
            : mygetOptionColorType === '4'
            ? NOC.GRAPH.OPTIONS.BCOLOR_BLUE_ONLY[0 + i] // 青系
            : mygetOptionColorType === '5'
            ? NOC.GRAPH.OPTIONS.BCOLOR_GREEN_ONLY[0 + i] // 緑系
            : NOC.GRAPH.OPTIONS.BCOLOR_BLUE_ONLY[0 + i],
        ); // 青系
        dataset.data = rangeList.map(v => v.list.length);
        dataset.tooltip = rangeList.map(v =>
          v.list.map(v2 => `${v2.label} (${valueFunc(Number(dataFunc(v2)))})`),
        );
      }
      return dataset;
    },
    setLabelsForMulti(
      dataset: any,
      isAverage: boolean,
      measureKey: string,
      gadgetDatas: IGraphData[],
    ) {
      const isDoughnut = this.selectGraphValue === NOC.CHARTS.DOUGHNUT;
      if (this.IS_MULTI && !isDoughnut) {
        dataset.labels = isAverage
          ? gadgetDatas.map(_ => `${measureKey} 平均`)
          : gadgetDatas.map(_ => measureKey);
        if (this.IS_COMPARE_GRAPH) {
          if (
            this.materials.some(
              v => v.id === NOC.MATERIAL.V3.MATERIAL.COMPARE_TYPE_AVERAGE.id,
            )
          ) {
            if (!isAverage) {
              // 比較元=集計, 比較先=平均
              dataset.labels[dataset.labels.length - 1] = `${measureKey} 平均`;
            }
          } else {
            if (isAverage) {
              // 比較元=平均, 比較先=集計
              dataset.labels[dataset.labels.length - 1] = measureKey;
            }
          }
        }
      }
    },

    clacValueToColor(value: number, min: number, max: number) {
      return clacValueToColor(value, min, max);
    },
  },
} as ThisTypedComponentOptionsWithRecordProps<Vue, Data, Methods, Computed, Props>);
